import Vue from 'vue'
import VueI18n from 'vue-i18n'
import flux_config from "../../public/flux_config.json"

Vue.use(VueI18n);

const translation = [ 
    {
        "Undefined" : {
            "en" : "Undefiend",
            "de" : "Undefiend",
            "nl" : "Undefiend",
            "it" : "non definito",
            "pl" : "Niezdefiniowany",
            "fr" : "Indéfini",
            "cs" : "Nedifinovaný",
            "sk" : "Nedifinovaný",
            "da" : "Udefineret",
            "es" : "Indefinido",
            "fi" : "Määrittelemätön",
            "sv" : "Odefinierad",
        },

        'Zurzeit in diesem Raum:' : { //SituationCard
            "en" : "Currently in this room:",
            "de" : "Zurzeit in diesem Raum:",
            "nl" : "Zurzeit in diesem Raum:",
            "it" : "Attualmente in questa stanza",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },

        'Ein Moderator hat die Session für Sie geschlossen!' : { //ForceDisconnect
            "en" : "A host has closed the session for you!",
            "de" : "Ein Moderator hat die Session für Sie geschlossen!",
            "nl" : "Ein Moderator hat die Session für Sie geschlossen!",
            "it" : "Un moderatore ha chiuso la sessione per te!",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },

        "Auf einen Moderator warten..." : { // WaitForModeratorDialogue
            "en" : "Waiting for a moderator...",
            "de" : "Auf einen Moderator warten...",
            "nl" : "Auf einen Moderator warten...",
            "it" : "Aspetta un moderatore...",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },

        // Roomnames
        'Empfang' : { 
            "de" : "Empfang",
            "en" : "Lobby",
            "it" : "Hall",
            "nl" : "Receptie",
            "pl" : "Recepcja",
            "fr" : "Réception",
            "cs" : "Recepce",
            "sk" : "Recepcia",
            "da" : "Lobby",
            "es" : "Recepción",
            "fi" : "Aula",
            "sv" : "Lobby",
        },
        'Digital Services' : { 
            "de" : "Digitale Services",
            "en" : "Digital Services",
            "it" : "Servizi digitali",
            "nl" : "Digital Services",
            "pl" : "Usługi cyfrowe",
            "fr" : "Services numériques",
            "cs" : "Digitální služby",
            "sk" : "Digitálne služby",
            "da" : "Digitale tjenester",
            "es" : "Servicios digitales",
            "fi" : "Digitaaliset palvelut",
            "sv" : "Digitala tjänster",
        },
        'Produktausstellung Start' : { 
            "de" : "Produktausstellung - Zentral",
            "en" : "Start",
            "it" : "Atelier dei prodotti - Centro",
            "nl" : "Showroom - Centraal",
            "pl" : "Wystawa produktów - Centrum",
            "fr" : "Exposition de produits - Centre",
            "cs" : "Výstava výrobků - Střed",
            "sk" : "Výstava výrobkov - Centrum",
            "da" : "Produktudstilling - Centret",
            "es" : "Exposición de productos - Centro",
            "fi" : "Tuote-esittely - Aloitus",
            "sv" : "Produktutställning - Mitten",
        },
        'Produktausstellung Lagerung Wannen' : { 
            "de" : "Gefahrstofflagerung - Auffangwannen",
            "en" : "Storage Tubs",
            "it" : "Atelier dei prodotti - Vasche di raccolta",
            "nl" : "Opslag van Gevaarlijke Stoffen - Opvangbakken",
            "pl" : "Magazyn materiałów niebezpiecznych - Wanny wychwytowe",
            "fr" : "Stockage de matières dangereuses - Palettes de déversement",
            "cs" : "Skladování nebezpečného materiálu - Záchytné vany",
            "sk" : "Skladovanie nebezpečných látok - Záchytné vane",
            "da" : "Opbevaring af farlige medier - Opsamlingskar",
            "es" : "Almacenamiento de materiales peligrosos - Palés para vertidos",
            "fi" : "Vaarallisten aineiden varastointi - Valuma-altaat",
            "sv" : "Kemikalieförvaring - Uppsamlingskärl",
        },
        'Produktausstellung Lagerung Depots' : { 
            "de" : "Gefahrstofflagerung - Depots",
            "en" : "Storage Depots",
            "it" : "Atelier dei prodotti - Box",
            "nl" : "Opslag van Gevaarlijke Stoffen - Depots",
            "pl" : "Wystawa produktów - Składy",
            "fr" : "Exposition de produits - Dépôts",
            "cs" : "Výstava výrobků - Depoty",
            "sk" : "Výstava výrobkov - Depoty",
            "da" : "Produktudstilling - Depoter",
            "es" : "Exposición de productos - Depósitos",
            "fi" : "Tuote-esittely - Varastokaapit",
            "sv" : "Produktutställning - IBC och fatinvallning",
        },
        'Produktausstellung Lithium-Ionen Lagerung' : { 
            "de" : "Lithium-Ionen-Lagerung",
            "en" : "Lithium Ion",
            "it" : "Stoccaggio batterie al litio",
            "nl" : "Lithium-Ion-Batterij opslag",
            "pl" : "Magazynowanie baterii litowo-jonowych",
            "fr" : "Stockage de batteries lithium-ion",
            "cs" : "Skladování lithium-iontových baterií",
            "sk" : "Skladovanie líthium-iónových batérií",
            "da" : "Opbevaring af lithium-ion-batterier",
            "es" : "Almacenamiento de baterías de iones de litio",
            "fi" : "Litiumakkujen varastointi",
            "sv" : "Batteriförvaring",
        },
        'Produktausstellung Gefahrstoffhandling' : { 
            "de" : "Gefahrstoffhandling",
            "en" : "Hazardous Material Handling",
            "it" : "Utilizzare sostanze pericolose",
            "nl" : "Handling van Gevaarlijke Stoffen",
            "pl" : "Magazynowanie materiałów niebezpiecznych",
            "fr" : "Manipulation de matières dangereuses",
            "cs" : "Manipulace s nebezpečnými materiály",
            "sk" : "Manipulácia s nebezpečnými látkami",
            "da" : "Håndtering af farlige medier",
            "es" : "Manipulación de materiales peligrosos",
            "fi" : "Vaarallisten aineiden käsittely",
            "sv" : "Kemikaliehantering",
        },
        'Außenbereich' : { 
            "en" : "Outdoor Area",
            "de" : "Außenbereich",
            "nl" : "Uitpandige Oplossingen",
            "it" : "Area esterna",
            "pl" : "Obszar zewnętrzny",
            "fr" : "Espace extérieur",
            "cs" : "Venkovní prostor",
            "sk" : "Vonkajší priestor",
            "da" : "Udendørs område",
            "es" : "Zona exterior",
            "fi" : "Ulkoalue",
            "sv" : "Utomhus",
        },

        // Tutorial
        "Tutorial":{
            "en" : "Tutorial",
            "de" : "Anleitung",
            "nl" : "Handleiding",
            "it" : "Tutorial",
            "pl" : "Tutorial",
            "fr" : "Tutoriel",
            "cs" : "Průvodce",
            "sk" : "Sprievodca",
            "da" : "Vejledning",
            "es" : "Tutorial",
            "fi" : "Ohjeistus",
            "sv" : "Handledning"
        },
        "tutorialSlide1_title": {
            "en" : "Discover the 3D-Showroom",
            "de" : "Entdecken Sie den 3D-Showroom",
            "nl" : "Ontdek de 3D-showroom",
            "it" : "Scoprite lo showroom 3D",
            "pl" : "Odkryj 3D-Showroom",
            "fr" : "Découvrez le showroom 3D",
            "cs" : "Objevte 3D-showroom",
            "sk" : "Objavte 3D-showroom",
            "da" : "Udforsk DENIOS 3D-showroom",
            "es" : "Descubra la sala de exposición 3D",
            "fi" : "Tutustu 3D-showroomiin",
            "sv" : "Utforska vårt 3D-showroom",
        },
        "tutorialSlide1": {
            "en" : "Welcome to the DENIOS 3D showroom. Here you can discover our products in an interactive way. In this tutorial we would like to briefly show you how to navigate through the showroom.",
            "de" : "Herzlich Willkommen im 3D-Showroom von DENIOS. Sie können hier auf interaktive Weise unsere Produkte entdecken. In diesem Tutorial möchten wir Ihnen kurz zeigen, wie Sie sich durch den Showroom navigieren.",
            "nl" : "Welkom in de showroom van DENIOS 3D. Hier kunt u onze producten op een interactieve manier ontdekken. In deze handleiding willen wij u kort laten zien hoe u door de showroom kunt navigeren.",
            "it" : "Benvenuti nello showroom DENIOS 3D, dove potrete scoprire i nostri prodotti grazie ad un'esperienza interattiva. Nel seguente tutorial vi mostriamo brevemente come navigare nello showroom.",
            "pl" : "Witamy w DENIOS 3D Showroom. Tutaj możesz w sposób interaktywny poznać nasze produkty. W tym poradniku chcemy Ci pokrótce  pokazać, jak się po nim poruszać.",
            "fr" : "Bienvenue dans le showroom 3D de DENIOS. Ici, vous pouvez découvrir nos produits de manière interactive. Dans ce tutoriel, nous aimerions vous montrer brièvement comment naviguer dans le showroom.",
            "cs" : "Vítejte v 3D showroomu DENIOS. Zde se můžete interaktivním způsobem seznámit s našimi výrobky. V tomto návodu bychom vám rádi stručně ukázali, jak se v showroomu pohybovat.",
            "sk" : "Vitajte v 3D showroome DENIOS. Tu sa môžete interaktívnym spôsobom zoznámiť s našimi výrobkami. V tomto návode by sme vám chceli stručne ukázať, ako sa pohybovať v showroome.",
            "da" : "Velkommen til vores 3D-showroom. Her kan du opleve vores produkter på en interaktiv måde. I denne vejledning vil vi kort vise dig, hvordan du navigerer rundt i showroomet.",
            "es" : "Bienvenido a la sala de exposición 3D de DENIOS. Aquí podrá descubrir nuestros productos de forma interactiva. En este tutorial queremos mostrarle brevemente cómo navegar por la sala de exposición.",
            "fi" : "Tervetuloa DENIOS 3D-showroomiin. Täällä voit tutustua tuotteisiimme interaktiivisella tavalla. Tässä ohjeistuksessa kerromme lyhyesti, miten navigoit näyttelytilassa.",
            "sv" : "Välkommen till DENIOS 3D-showroom. Här kan du gå runt och utforska våra olika produkter. I den här handledningen vill vi kort visa dig hur du navigerar i showroomet.",
        },
        "tutorialSlide2_title": {
            "en" : "Discovering the Showroom",
            "de" : "Den Showroom entdecken",
            "nl" : "Ontdek de showroom",
            "it" : "Scoprire lo showroom",
            "pl" : "Odkrywanie salonu wystawowego",
            "fr" : "Découvrir le showroom",
            "cs" : "Procházení showroomu",
            "sk" : "Prechádzanie showroomu",
            "da" : "Gå på opdagelse i showroomet",
            "es" : "Descubrir la sala de exposición",
            "fi" : "Showroomissa liikkuminen",
            "sv" : "Utforska showroomet",
        },
        "tutorialSlide2": {
            "en" : "While holding down the mouse button, move your mouse left/right to explore the room.",
            "de" : "Bewegen Sie Ihre Maus mit gedrückter Maustaste nach links/rechts, um den Raum zu erkunden.",
            "nl" : "Terwijl je de muisknop ingedrukt houdt, beweeg je de muis naar links/rechts om de kamer te verkennen.",
            "it" : "Tenendo premuto il pulsante del mouse, muovete il mouse a destra e a sinistra per esplorare la stanza.",
            "pl" : "Trzymając wciśnięty przycisk myszy, poruszaj myszą w lewo/prawo, aby odkryć pomieszczenie.",
            "fr" : "Tout en maintenant le bouton de la souris enfoncé, déplacez votre souris vers la gauche et la droite pour explorer la salle.",
            "cs" : "Držte stisknuté tlačítko myši, pohybujte myší doleva/doprava a prozkoumejte místnost.",
            "sk" : "Držte stlačené tlačidlo myši, pohybujte myšou doľava/doprava a preskúmajte miestnosť.",
            "da" : "Kig rundt i rummet ved at holde museknappen nede, mens du bevæger musen til højre eller venstre.",
            "es" : "Mientras mantiene pulsado el botón del ratón, muévalo hacia la izquierda o hacia la derecha para explorar la sala.",
            "fi" : "Pidä hiiren painiketta alhaalla ja liikuta hiirtä vasemmalle/oikealle tutustuaksesi huoneeseen.",
            "sv" : "Medan du håller ner musknappen rör du musen till vänster/höger för att utforska rummet.",
        },
        "tutorialSlide3_title": {
            "en" : "Discovering the Showroom",
            "de" : "Den Showroom entdecken",
            "nl" : "Ontdek de showroom",
            "it" : "Scoprire lo showroom",
            "pl" : "Odkrywanie salonu wystawowego",
            "fr" : "Découvrir le showroom",
            "cs" : "Objevování showroomu",
            "sk" : "Objavovanie showroomu",
            "da" : "Gå på opdagelse i showroomet",
            "es" : "Descubrir la sala de exposición",
            "fi" : "Showroomissa liikkuminen",
            "sv" : "Utforska showroomet",
        },
        "tutorialSlide3": {
            "en" : "Roll your mouse wheel back and forth to move closer and further away from objects.",
            "de" : "Bewegen Sie Ihr Mausrad vor und zurück, um näher an die Objekte heran und weiter von den Objekten wegzutreten.",
            "nl" : "Beweeg je muiswiel heen en weer om dichter bij en verder weg van de objecten te komen.",
            "it" : "Ruotare la rotella del mouse per avvicinarsi o allontanarsi dagli oggetti.",
            "pl" : "Przesuwaj kółko myszy w przód i w tył, aby przybliżać i oddalać obiekty.",
            "fr" : "Faites glisser la molette de votre souris d'avant en arrière pour vous rapprocher ou vous éloigner des objets.",
            "cs" : "Otáčením kolečka myši dopředu a dozadu si můžete přiblížit a oddálit objekty.",
            "sk" : "Otáčaním kolieska myši dopredu a dozadu si môžete priblížiť a oddialiť objekty.",
            "da" : "Zoom ud og ind med musen for at bevæge dig tættere eller længere væk fra objekterne.",
            "es" : "Mueve la rueda del ratón hacia delante y hacia atrás para acercarte o alejarte de los objetos.",
            "fi" : "Vieritä hiiren pyörää edestakaisin siirtyäksesi lähemmäksi tai kauemmaksi esineestä.",
            "sv" : "Rulla mushjulet fram och tillbaka för att gå närmare och längre bort från objekt.",
        },
        "tutorialSlide4_title": {
            "en" : "Tutorial",
            "de" : "Tutorial",
            "nl" : "Handleiding",
            "it" : "Tutorial",
            "pl" : "Samouczek",
            "fr" : "Tutoriel",
            "cs" : "Návod k použití",
            "sk" : "Návod",
            "da" : "Vejledning",
            "es" : "Tutorial",
            "fi" : "Ohjeistus",
            "sv" : "Handledning",
        },
        "tutorialSlide4": {
            "en" : "By clicking on this icon you can call up this tutorial again.",
            "de" : "Durch Klicken auf dieses Icon können Sie dieses Tutorial erneut aufrufen.",
            "nl" : "Door op dit pictogram te klikken kunt u deze handleiding opnieuw oproepen.",
            "it" : "Facendo clic su questa icona è possibile aprire il tutorial relativo al prodotto visualizzato.",
            "pl" : "Klikając tę ikonę, można ponownie wyświetlić ten tutorial.",
            "fr" : "En cliquant sur cette icône, vous pouvez rappeler ce tutoriel.",
            "cs" : "Kliknutím na tuto ikonu znovu otevřete tohoto průvodce.",
            "sk" : "Kliknutím na túto ikonu znova otvoríte tohto sprievodcu.",
            "da" : "Du kan altid åbne denne vejledning igen ved at klikke på dette ikon.",
            "es" : "Haciendo clic en este icono puedes volver a acceder a este tutorial.",
            "fi" : "Klikkaamalla tätä kuvaketta voit palata tähän käyttöohjeistukseen.",
            "sv" : "Genom att klicka på den här ikonen kan se den här handledningen igen.",
        },
        "tutorialSlide5_title": {
            "en" : "Fullscreen Mode",
            "de" : "Vollbildmodus",
            "nl" : "Volledig scherm",
            "it" : "Modalità a schermo intero",
            "pl" : "Tryb pełnoekranowy",
            "fr" : "Mode plein écran",
            "cs" : "Režim celé obrazovky",
            "sk" : "Režim celej obrazovky",
            "da" : "Fuldskærmstilstand",
            "es" : "Modo de pantalla completa",
            "fi" : "Koko ruudun tila",
            "sv" : "Helskärmsläge",
        },
        "tutorialSlide5": {
            "en" : "Clicking on this icon displays the entire showroom in full screen mode. You can undo this by clicking again or by pressing the Esc key.",
            "de" : "Durch Klicken auf dieses Icon wird der gesamte Showroom im Vollbildmodus dargestellt. Durch erneutes Klicken oder Drücken der Esc-Taste machen Sie dies wieder rückgängig.",
            "nl" : "Door op dit pictogram te klikken, wordt de hele showroom op volledig scherm weergegeven. Klik opnieuw of druk op de Esc-toets om dit ongedaan te maken.",
            "it" : "Facendo clic su questa icona si visualizza l'intera sala espositiva a schermo intero. È possibile annullare l'operazione facendo cliccando nuovamente o premendo il tasto Esc.",
            "pl" : "Kliknięcie na tę ikonę powoduje wyświetlenie całego salonu w trybie pełnoekranowym. Możesz to cofnąć klikając ponownie lub naciskając klawisz Esc.",
            "fr" : "En cliquant sur cette icône, vous affichez l'ensemble de la salle d'exposition en mode plein écran. Vous pouvez annuler cette opération en cliquant à nouveau ou en appuyant sur la touche Echap.",
            "cs" : "Kliknutím na tuto ikonu zobrazíte showroom v celoobrazovkovém režimu. Tento krok můžete zrušit opětovným kliknutím nebo stisknutím klávesy Esc.",
            "sk" : "Kliknutím na túto ikonu zobrazíte showroom v režime celej obrazovky. Tento krok môžete zrušiť opätovným kliknutím alebo stlačením tlačidla Esc.",
            "da" : "Når du klikker på dette ikon, kan du se hele showroomet i fuldskærmstilstand. Du kan fortryde ved at klikke igen eller ved at trykke på Esc-tasten.",
            "es" : "Al hacer clic en este icono se muestra toda la sala de exposición a pantalla completa. Puede deshacer esta acción haciendo clic de nuevo o pulsando la tecla Esc.",
            "fi" : "Tätä kuvaketta painamalla näyttelyhuone näytetään koko näytön tilassa. Voit peruuttaa tämän napsauttamalla painiketta uudelleen tai painamalla Esc-näppäintä.",
            "sv" : "Om du klickar på den här ikonen visas hela utställningsrummet i helskärmsläge. Du kan ångra detta genom att klicka igen eller genom att trycka på Esc-tangenten.",
        },
        "tutorialSlide6_title": {
            "en" : "Contact",
            "de" : "Kontakt",
            "nl" : "Contact",
            "it" : "Contatti",
            "pl" : "Kontakt",
            "fr" : "Contactez",
            "cs" : "Kontakt",
            "sk" : "Kontakt",
            "da" : "Kontakt",
            "es" : "Póngase en contacto con",
            "fi" : "Ota yhteyttä",
            "sv" : "Kontakta oss",
        },
        "tutorialSlide6": {
            "en" : "You can contact us at any time by clicking on this icon",
            "de" : "Durch Klicken auf dieses Icon können Sie jederzeit Kontakt zu uns aufnehmen",
            "nl" : "Door op dit pictogram te klikken kunt u te allen tijde contact met ons opnemen",
            "it" : "È possibile contattarci in qualsiasi momento facendo clic su questa icona.",
            "pl" : "Możesz się z nami skontaktować w każdej chwili klikając na tę ikonę.",
            "fr" : "Vous pouvez nous contacter à tout moment en cliquant sur cette icône.",
            "cs" : "Kliknutím na tuto ikonu nás můžete kontaktovat.",
            "sk" : "Kliknutím na túto ikonu nás môžete kontaktovať.",
            "da" : "Du kan altid kontakte os ved at klikke på dette ikon.",
            "es" : "Puede ponerse en contacto con nosotros en cualquier momento haciendo clic en este icono.",
            "fi" : "Voit ottaa meihin yhteyttä milloin tahansa klikkaamalla tätä kuvaketta.",
            "sv" : "Du kan när som helst kontakta oss genom att klicka på den här ikonen.",
        },
        "tutorialSlide7_title": {
            "en" : "Content Items",
            "de" : "Inhaltselemente",
            "nl" : "Inhoudelijke elementen",
            "it" : "Informazioni sul prodotto",
            "pl" : "Elementy treści",
            "fr" : "Éléments de contenu",
            "cs" : "Položky obsahu",
            "sk" : "Položky obsahu",
            "da" : "Indhold",
            "es" : "Contenido",
            "fi" : "Sisältökuvakkeet",
            "sv" : "Innehåll",
        },
        "tutorialSlide7": {
            "en" : "By clicking on these icons you will receive further information on the respective products.",
            "de" : "Durch Klicken auf diese Icons erhalten Sie weitere Informationen zu den jeweiligen Produkten.",
            "nl" : "Door op deze pictogrammen te klikken krijgt u meer informatie over de betreffende producten.",
            "it" : "Facendo clic su queste icone si ottengono ulteriori informazioni sui prodotti visualizzati.",
            "pl" : "Klikając na te ikony otrzymają Państwo dalsze informacje na temat poszczególnych produktów.",
            "fr" : "En cliquant sur ces icônes, vous recevrez des informations supplémentaires sur les produits respectifs.",
            "cs" : "Kliknutím na tyto ikony získáte další informace o daných produktech.",
            "sk" : "Kliknutím na tieto ikony získate ďalšie informácie o príslušných produktoch.",
            "da" : "Du kan finde flere oplysninger om de respektive produkter ved at klikke på disse ikoner.",
            "es" : "Haciendo clic en estos iconos obtendrá más información sobre los respectivos productos.",
            "fi" : "Klikkaamalla näitä kuvakkeita saat lisätietoja kyseisistä tuotteista.",
            "sv" : "Genom att klicka på dessa ikoner får du ytterligare information om respektive produkt.",
        },
        "tutorialSlide8_title": {
            "en" : "Shop",
            "de" : "Shop",
            "nl" : "Shop",
            "it" : "Shop",
            "pl" : "Sklep",
            "fr" : "Boutique",
            "cs" : "E-shop",
            "sk" : "E-shop",
            "da" : "Shop",
            "es" : "Tienda",
            "fi" : "Verkkokauppa",
            "sv" : "Shop",
        },
        "tutorialSlide8": {
            "en" : "By clicking on this icon you can access the DENIOS shop at any time.",
            "de" : "Durch Klicken auf dieses Icon haben Sie jederzeit die Möglichkeit, in den DENIOS Shop zu gelangen.",
            "nl" : "Door op dit pictogram te klikken, heeft u op elk moment toegang tot de DENIOS Shop.",
            "it" : "Facendo clic su questa icona è possibile accedere allo shop DENIOS in qualsiasi momento.",
            "pl" : "Klikając na tę ikonę, mogą Państwo w każdej chwili wejść do sklepu DENIOS.",
            "fr" : "En cliquant sur cette icône, vous pouvez accéder à tout moment à la boutique DENIOS.",
            "cs" : "Kliknutím na tuto ikonu vstoupíte do DENIOS shopu.",
            "sk" : "Kliknutím na túto ikonu vstúpite do DENIOS shopu.",
            "da" : "Du kan altid åbne vores shop ved at klikke på dette ikon.",
            "es" : "Haciendo clic en este icono podrá acceder en cualquier momento a la tienda de DENIOS.",
            "fi" : "Klikkaamalla tätä kuvaketta pääset suoraan DENIOS-verkkokauppaan.",
            "sv" : "Genom att klicka på den här ikonen kan du gå direkt till DENIOS shop och handla.",
        },
        "Abschließen": {
            "en" : "Complete",
            "de" : "Abschließen",
            "nl" : "Sluiten",
            "it" : "Fine",
            "pl" : "Rozumiem",
            "fr" : "Complète",
            "cs" : "Ukončit průvodce",
            "sk" : "Ukončiť sprievodcu",
            "da" : "Færdig",
            "es" : "Completo",
            "fi" : "Sulje",
            "sv" : "Klart!",
        },

        // LoginDialogue
        "Anzeigename": {
            "en" : "Displayed name",
            "de" : "Anzeigename",
            "nl" : "Weergavenaam",
            "it" : "Nome visualizzato",
            "pl" : "Wyświetlana nazwa",
            "fr" : "Nom affiché",
            "cs" : "Zobrazené jméno",
            "sk" : "Zobrazené meno",
            "da" : "Vist navn",
            "es" : "Nombre mostrado",
            "fi" : "Nimi",
            "sv" : "Visat namn",
        },
        "Email": {
            "en" : "Email",
            "de" : "E-Mail",
            "nl" : "E-mailadres",
            "it" : "Email",
            "pl" : "E-mail",
            "fr" : "Courriel",
            "cs" : "E-mail",
            "sk" : "E-mail",
            "da" : "E-mail",
            "es" : "Correo electrónico",
            "fi" : "Sähköposti",
            "sv" : "E-post",
        },
        "Passwort": {
            "en" : "Password",
            "de" : "Passwort",
            "nl" : "Wachtwoord",
            "it" : "Password di accesso",
            "pl" : "Hasło",
            "fr" : "Mot de passe",
            "cs" : "Heslo",
            "sk" : "Heslo",
            "da" : "Adgangskode",
            "es" : "Contraseña",
            "fi" : "Salasana",
            "sv" : "Lösenord",
        },
        "Gast": {
            "en" : "Guest",
            "de" : "Gast",
            "nl" : "Gast",
            "it" : "Ospite",
            "pl" : "Gość",
            "fr" : "Invité",
            "cs" : "Host",
            "sk" : "Hosť",
            "da" : "Gæst",
            "es" : "Invitado",
            "fi" : "Vieras",
            "sv" : "Gäst",
        },
        "Moderator": {
            "en" : "Host",
            "de" : "Moderator",
            "nl" : "Moderator",
            "it" : "Tecnico DENIOS",
            "pl" : "Host",
            "fr" : "Hôte",
            "cs" : "Hostitel",
            "sk" : "Hostiteľ",
            "da" : "Vært",
            "es" : "Anfitrión",
            "fi" : "Edustaja",
            "sv" : "Värd",
        },
        "Abbrechen": {
            "en" : "Cancel",
            "de" : "Abbrechen",
            "nl" : "Afbreken",
            "it" : "Interrompere",
            "pl" : "Anulować",
            "fr" : "Annuler",
            "cs" : "zrušení",
            "sk" : "Zrušiť",
            "da" : "Afbestille",
            "es" : "Cancelar",
            "fi" : "Peruuttaa",
            "sv" : "Annullera",
        },
        "Weiter": {
            "en" : "Continue",
            "de" : "Weiter",
            "nl" : "Doorgaan",
            "it" : "Continua",
            "pl" : "Kontynuuj",
            "fr" : "Continuer",
            "cs" : "Pokračovat",
            "sk" : "Pokračovať",
            "da" : "Fortsæt",
            "es" : "Continuar",
            "fi" : "Jatka",
            "sv" : "Gå vidare",
        },
        "Die Email und/oder das Passwort ist falsch.": {
            "en" : "The Email and/or the password are incorrect",
            "de" : "Die E-Mail und/oder das Passwort ist falsch.",
            "nl" : "Het w-mailadres en/of wachtwoord is onjuist.",
            "it" : "L'e-mail e/o la password non sono corrette",
            "pl" : "E-mail i/lub hasło są nieprawidłowe",
            "fr" : "L'email et/ou le mot de passe sont incorrects",
            "cs" : "E-mail a/nebo heslo jsou nesprávné",
            "sk" : "E-mail a/alebo heslo sú nesprávne",
            "da" : "Forkert e-mail og/eller adgangskode",
            "es" : "El Email y/o la contraseña son incorrectos",
            "fi" : "Sähköpostiosoite ja/tai salasana ovat väärin",
            "sv" : "E-postadressen och/eller lösenordet är felaktiga",
        },

        // AudioVideoDialogue
        "Mikrofon- und Kameraeinstellungen": {
            "en" : "Microphone and camera settings",
            "de" : "Mikrofon- und Kameraeinstellungen",
            "nl" : "Microfoon- en camera-instellingen",
            "it" : "Impostazioni del microfono e della telecamera ",
            "pl" : "Ustawienia mikrofonu i kamery",
            "fr" : "Paramètres du microphone et de la caméra",
            "cs" : "Nastavení mikrofonu a kamery",
            "sk" : "Nastavenia mikrofónu a kamery",
            "da" : "Indstillinger for mikrofon og kamera",
            "es" : "Ajustes del micrófono y la cámara",
            "fi" : "Mikrofonin ja kameran asetukset",
            "sv" : "Inställningar för mikrofon och kamera",
        },
        "Audiotest": {
            "en" : "Audio Test",
            "de" : "Audiotest",
            "nl" : "Audiotest",
            "it" : "Test audio",
            "pl" : "Test audio",
            "fr" : "Test audio",
            "cs" : "Test zvuku",
            "sk" : "Test zvuku",
            "da" : "Lydtest",
            "es" : "Prueba de audio",
            "fi" : "Äänitesti",
            "sv" : "Ljudtest",
        },
        "Browser-Zugriff auf Ihre Kamera wurde nicht erlaubt. Klicken Sie": {
            "en" : "You denied the permission to access your camera. Please click",
            "de" : "Browser-Zugriff auf Ihre Kamera wurde nicht erlaubt. Klicken Sie",
            "nl" : "Browsertoegang tot uw camera is niet toegestaan. Klik",
            "it" : "È stata negata l'autorizzazione ad accedere alla videocamera. Cliccare",
            "pl" : "Odmówiono zgody na dostęp do kamery. Proszę kliknąć",
            "fr" : "Vous avez refusé l'autorisation d'accéder à votre caméra. Veuillez cliquer",
            "cs" : "Odmítli jste oprávnění k přístupu k fotoaparátu. Klepněte na tlačítko",
            "sk" : "Odmietli ste povolenie na prístup k fotoaparátu. Kliknite na tlačidlo",
            "da" : "Du har nægtet adgang til dit kamera. Klik venligst",
            "es" : "Se le ha denegado el permiso para acceder a su cámara. Haga clic",
            "fi" : "Sinulta evättiin oikeus käyttää kameraa. Paina",
            "sv" : "Du har inte tillgång till kameran. Klicka",
        },
        "hier": {
            "en" : "here",
            "de" : "hier",
            "nl" : "hier",
            "it" : "qui",
            "pl" : "tutaj",
            "fr" : "ici",
            "cs" : "zde",
            "sk" : "tu",
            "da" : "her",
            "es" : "aquí",
            "fi" : "tästä",
            "sv" : "här",
        },
        ", um nach dem Zugriff gefragt zu werden.": {
            "en" : "to be asked for access again.",
            "de" : ", um nach dem Zugriff gefragt zu werden.",
            "nl" : "om toegang te krijgen.",
            "it" : "per richiedere nuovamente l'accesso.",
            "pl" : "aby zostać ponownie poproszonym o dostęp.",
            "fr" : "pour que l'on vous demande à nouveau l'accès.",
            "cs" : "abyste byli znovu požádáni o přístup.",
            "sk" : "aby ste boli znovu požiadaní o prístup.",
            "da" : "for at blive bedt om adgang igen.",
            "es" : "para que se le solicite de nuevo el acceso.",
            "fi" : "jotta sinulta pyydetään käyttöoikeutta uudelleen.",
            "sv" : "för att få åtkomst igen.",
        },
        "Es wurde keine Kamera erkannt": {
            "en" : "No camera was detected",
            "de" : "Es wurde keine Kamera erkannt",
            "nl" : "Er is geen camera gedetecteerd",
            "it" : "Non è stata rilevata alcuna telecamera",
            "pl" : "Nie wykryto żadnej kamery",
            "fr" : "Aucune caméra n'a été détectée",
            "cs" : "Nebyla nalezena žádná kamera",
            "sk" : "Nebola zistená žiadna kamera",
            "da" : "Der blev ikke fundet noget kamera",
            "es" : "No se ha detectado ninguna cámara",
            "fi" : "Kameraa ei havaittu",
            "sv" : "Ingen kamera upptäcktes",
        },
        "Kamera": {
            "en" : "Camera",
            "de" : "Kamera",
            "nl" : "Camera",
            "it" : "Videocamera",
            "pl" : "Kamera",
            "fr" : "Caméra",
            "cs" : "Kamera",
            "sk" : "Kamera",
            "da" : "Kamera",
            "es" : "Cámara",
            "fi" : "Kamera",
            "sv" : "Kamera",
        },
        "Browser-Zugriff auf Ihr Mikrofon wurde nicht erlaubt. Klicken Sie": {
            "en" : "You denied the permission to access your microphone. Please click",
            "de" : "Browser-Zugriff auf Ihr Mikrofon wurde nicht erlaubt. Klicken Sie",
            "nl" : "Browsertoegang tot uw microfoon is niet toegestaan. Klik",
            "it" : "È stata negata l'autorizzazione ad accedere al microfono. Cliccare",
            "pl" : "Odmówiono zgody na dostęp do mikrofonu. Proszę kliknąć",
            "fr" : "Vous avez refusé l'autorisation d'accéder à votre microphone. Veuillez cliquer sur",
            "cs" : "Odmítli jste oprávnění k přístupu k mikrofonu. Klepněte prosím na tlačítko",
            "sk" : "Odmietli ste povolenie na prístup k mikrofónu. Kliknite na tlačidlo",
            "da" : "Du har nægtet adgang til din mikrofon. Klik venligst",
            "es" : "Se le ha denegado el permiso para acceder a su micrófono. Haga clic en",
            "fi" : "Kielsit oikeuden käyttää mikrofonia. Paina",
            "sv" : "Du nekade åtkomst till din mikrofon. Klicka",
        },
        "Es wurde keine Mikrofon erkannt": {
            "en" : "No microphone was detected",
            "de" : "Es wurde kein Mikrofon erkannt",
            "nl" : "Er is geen microfoon gedetecteerd",
            "it" : "Non è stato rilevato alcun microfono",
            "pl" : "Nie wykryto mikrofonu",
            "fr" : "Aucun microphone n'a été détecté",
            "cs" : "Nebyl nalezen žádný mikrofon",
            "sk" : "Nebol zistený žiadny mikrofón",
            "da" : "Der blev ikke fundet nogen mikrofon",
            "es" : "No se ha detectado ningún micrófono",
            "fi" : "Mikrofonia ei havaittu",
            "sv" : "Ingen mikrofon upptäcktes",
        },
        "Mikrofon": {
            "en" : "Microphone",
            "de" : "Mikrofon",
            "nl" : "Microfoon",
            "it" : "Microfono",
            "pl" : "Mikrofon",
            "fr" : "Microphone",
            "cs" : "Mikrofon",
            "sk" : "Mikrofón",
            "da" : "Mikrofon",
            "es" : "Micrófono",
            "fi" : "Mikrofoni",
            "sv" : "Mikrofon",
        },
        "Zurück": {
            "en" : "Back",
            "de" : "Zurück",
            "nl" : "Terug",
            "it" : "Indietro",
            "pl" : "Powrót",
            "fr" : "Retour",
            "cs" : "Zpět",
            "sk" : "Späť",
            "da" : "Tilbage",
            "es" : "Volver",
            "fi" : "Takaisin",
            "sv" : "Tillbaka",
        },
        "Jetzt teilnehmen": {
            "en" : "Enter",
            "de" : "Jetzt teilnehmen",
            "nl" : "Doe nu mee",
            "it" : "Partecipa ora",
            "pl" : "Weź udział teraz",
            "fr" : "Participez maintenant",
            "cs" : "Zúčastněte se nyní",
            "sk" : "Zúčastnite sa teraz",
            "da" : "Deltag nu",
            "es" : "Participa ahora",
            "fi" : "Osallistu nyt",
            "sv" : "Delta nu",
        },
        "Problembehandlung": {
            "en" : "Troubleshooting",
            "de" : "Problembehandlung",
            "nl" : "Probleemoplossen",
            "it" : "Risoluzione dei problemi",
            "pl" : "Wykrywanie i usuwanie błędów",
            "fr" : "Dépannage",
            "cs" : "Řešení problémů",
            "sk" : "Riešenie problémov",
            "da" : "Fejlfinding",
            "es" : "Solución de problemas",
            "fi" : "Vianmääritys",
            "sv" : "Felsökning",
        },
        "Verbindungstest": {
            "en" : "Connection Test",
            "de" : "Verbindungstest",
            "nl" : "Verbindungstest",
            "it" : "Test di connessione",
            "pl" : "Test połączenia",
            "fr" : "Test de connexion",
            "cs" : "Test připojení",
            "sk" : "Test pripojenia",
            "da" : "Test din forbindelse",
            "es" : "Prueba de conexión",
            "fi" : "Yhteyden testaus",
            "sv" : "Test av anslutning",
        },

        // Connection Test
        "Ihre Verbindung wird überprüft": {
            "en" : "Checking your connection",
            "de" : "Ihre Verbindung wird überprüft",
            "nl" : "Uw verbinding wordt geverifieerd",
            "it" : "Stiamo verificando la connessione",
            "pl" : "Sprawdzanie połączenia",
            "fr" : "Vérification de votre connexion",
            "cs" : "Kontrola připojení",
            "sk" : "Kontrola pripojenia",
            "da" : "Tester din forbindelse",
            "es" : "Comprobación de la conexión",
            "fi" : "Yhteyden tarkistaminen",
            "sv" : "Kontrollera din anslutning",
        },
        "Der Verbindungsaufbau war erfolgreich": {
            "en" : "The connection buildup was successful",
            "de" : "Der Verbindungsaufbau war erfolgreich",
            "nl" : "Het instellen van de verbinding is gelukt",
            "it" : "Connessione riuscita",
            "pl" : "Połączenie zostało nawiązane pomyślnie",
            "fr" : "L'établissement de la connexion a réussi",
            "cs" : "Vytvoření připojení proběhlo úspěšně",
            "sk" : "Vytvorenie spojenia bolo úspešné",
            "da" : "Forbindelsesoprettelsen lykkedes",
            "es" : "La conexión se ha establecido correctamente",
            "fi" : "Yhteyden muodostaminen onnistui",
            "sv" : "Uppkopplingen av anslutningen lyckades",
        },
        "Der Verbindungsaufbau war nicht erfolgreich": {
            "en" : "The connection buildup was not successful",
            "de" : "Der Verbindungsaufbau war nicht erfolgreich",
            "nl" : "Het tot stand brengen van de verbinding is niet gelukt",
            "it" : "Connessione non è riuscita",
            "pl" : "Nawiązanie połączenia nie powiodło się",
            "fr" : "L'établissement de la connexion n'a pas réussi",
            "cs" : "Vytvoření spojení nebylo úspěšné",
            "sk" : "Vytvorenie spojenia nebolo úspešné",
            "da" : "Forbindelsesoprettelsen mislykkedes",
            "es" : "La conexión no se ha establecido correctamente",
            "fi" : "Yhteyden muodostaminen ei onnistunut",
            "sv" : "Uppkoppling av anslutningen misslyckades",
        },
        "Folgende Fehler sind aufgetreten:": {
            "en" : "The following errors occurred:",
            "de" : "Folgende Fehler sind aufgetreten:",
            "nl" : "De volgende fouten zijn opgetreden:",
            "it" : "Si sono verificati i seguenti errori:",
            "pl" : "Wystąpiły następujące błędy:",
            "fr" : "Les erreurs suivantes se sont produites :",
            "cs" : "Vyskytly se následující chyby:",
            "sk" : "Vyskytli sa nasledujúce chyby:",
            "da" : "Følgende fejl opstod:",
            "es" : "Se han producido los siguientes errores:",
            "fi" : "Tapahtui seuraavat virheet:",
            "sv" : "Följande fel inträffade:",
        },
        "Ihre Verbindungsqualität wird überprüft": {
            "en" : "Checking the quality of the connection",
            "de" : "Ihre Verbindungsqualität wird überprüft",
            "nl" : "Uw verbindingskwaliteit wordt gecontroleerd",
            "it" : "Verifica della qualità della connessione",
            "pl" : "Sprawdzanie jakości połączenia",
            "fr" : "Vérification de la qualité de la connexion",
            "cs" : "Kontrola kvality připojení",
            "sk" : "Kontrola kvality pripojenia",
            "da" : "Tester forbindelsens kvalitet",
            "es" : "Comprobación de la calidad de la conexión",
            "fi" : "Yhteyden laadun tarkistaminen",
            "sv" : "Kontrollera kvaliteten på anslutningen",
        },
        "Die Überprüfung ihrer Verbindungsqualität war erfolgreich": {
            "en" : "Checking the quality of the connection was successful",
            "de" : "Die Überprüfung ihrer Verbindungsqualität war erfolgreich",
            "nl" : "De kwaliteitscontrole van uw verbinding is gelukt",
            "it" : "La verifica della qualità della connessione è riuscita",
            "pl" : "Sprawdzanie jakości połączenia zakończyło się sukcesem",
            "fr" : "La vérification de la qualité de la connexion a réussi",
            "cs" : "Kontrola kvality připojení byla úspěšná",
            "sk" : "Kontrola kvality pripojenia bola úspešná",
            "da" : "Testen af forbindelsens kvalitet var vellykket",
            "es" : "La comprobación de la calidad de la conexión se ha realizado correctamente.",
            "fi" : "Yhteyden laadun tarkistaminen onnistui",
            "sv" : "Kontrollera anslutningens kvalitet ",
        },
        "Ergebniss des Tests:": {
            "en" : "Results of the test:",
            "de" : "Ergebnisse des Tests:",
            "nl" : "Resultaten van de test:",
            "it" : "Risultati del test:",
            "pl" : "Wyniki testu:",
            "fr" : "Résultats du test :",
            "cs" : "Výsledky testu:",
            "sk" : "Výsledky testu:",
            "da" : "Testresultater:",
            "es" : "Resultados de la prueba:",
            "fi" : "Testin tulokset:",
            "sv" : "Resultat av testet:",
        },
        "Fehler bei der Video Übertragung:": {
            "en" : "Video transmission error:",
            "de" : "Fehler bei der Video-Übertragung:",
            "nl" : "Videotransmissiefout:",
            "it" : "Errore di trasmissione video:",
            "pl" : "Błąd transmisji wideo:",
            "fr" : "Erreur de transmission vidéo :",
            "cs" : "Chyba přenosu videa:",
            "sk" : "Chyba prenosu videa:",
            "da" : "Fejl i videotransmissionen:",
            "es" : "Error de transmisión de vídeo:",
            "fi" : "Videonsiirtovirhe:",
            "sv" : "Resultat: Fel i videoöverföringen:",
        },
        "Fehler bei der Audio Übertragung:": {
            "en" : "Audio transmission error:",
            "de" : "Fehler bei der Audio-Übertragung:",
            "nl" : "Audiotransmissiefout:",
            "it" : "Errore di trasmissione audio:",
            "pl" : "Błąd transmisji audio:",
            "fr" : "Erreur de transmission audio :",
            "cs" : "Chyba přenosu zvuku:",
            "sk" : "Chyba prenosu zvuku:",
            "da" : "Fejl i lydtransmissionen:",
            "es" : "Error de transmisión de audio:",
            "fi" : "Äänen siirtovirhe:",
            "sv" : "Fel i ljudöverföringen:",
        },
        "Folgender Fehler ist aufgetreten:": {
            "en" : "The following error occurred:",
            "de" : "Folgender Fehler ist aufgetreten:",
            "nl" : "De volgende fout is opgetreden:",
            "it" : "Si è verificato il seguente errore:",
            "pl" : "Wystąpił następujący błąd:",
            "fr" : "L'erreur suivante s'est produite :",
            "cs" : "Došlo k následující chybě:",
            "sk" : "Vyskytla sa nasledujúca chyba:",
            "da" : "Der er opstået følgende fejl:",
            "es" : "Se ha producido el siguiente error:",
            "fi" : "Seuraava virhe tapahtui:",
            "sv" : "Följande fel har inträffat:",
        },
        "Der Qualitäts Test konnte nicht durchgeführt werden!": {
            "en" : "Checking the quality of the connection was not successful",
            "de" : "Die Überprüfung der Verbindungsqualität konnte nicht durchgeführt werden!",
            "nl" : "De kwaliteitstest kon niet worden uitgevoerd!",
            "it" : "La verifica della qualità della connessione non è riuscita",
            "pl" : "Sprawdzanie jakości połączenia nie powiodło się",
            "fr" : "La vérification de la qualité de la connexion n'a pas abouti.",
            "cs" : "Kontrola kvality připojení nebyla úspěšná.",
            "sk" : "Kontrola kvality spojenia nebola úspešná",
            "da" : "Testen af forbindelsens kvalitet mislykkedes",
            "es" : "La comprobación de la calidad de la conexión no se ha realizado correctamente.",
            "fi" : "Yhteyden laadun tarkistaminen ei onnistunut.",
            "sv" : "Kontrollen av kvaliteten på anslutningen lyckades inte.",
        },
        "Test Wiederholen": {
            "en" : "Repeat test",
            "de" : "Test wiederholen",
            "nl" : "Test herhaling",
            "it" : "Ripetere il test",
            "pl" : "Powtórzenie testu",
            "fr" : "Répétez le test",
            "cs" : "Opakujte test",
            "sk" : "Opakujte test",
            "da" : "Gentag testen",
            "es" : "Repita la prueba",
            "fi" : "Toista testi",
            "sv" : "Upprepa testet",
        },
        "Qualität": {
            "en" : "Quality",
            "de" : "Qualität",
            "nl" : "Kwaliteit",
            "it" : "Qualità",
            "pl" : "Jakość",
            "fr" : "Qualité",
            "cs" : "Kvalita",
            "sk" : "Kvalita",
            "da" : "Kvalitet",
            "es" : "Calidad",
            "fi" : "Laatu",
            "sv" : "Kvalitet",
        },
        "Fertig": {
            "en" : "Done",
            "de" : "Fertig",
            "nl" : "Klaar",
            "it" : "Fatto",
            "pl" : "Gotowe",
            "fr" : "Terminé",
            "cs" : "Hotovo",
            "sk" : "Hotovo",
            "da" : "Udført",
            "es" : "Realizado",
            "fi" : "Valmis",
            "sv" : "Klar",
        },

        // Bugreport
        "Fehlerbericht senden": {
            "en" : "Send Error Report",
            "de" : "Fehlerbericht senden",
            "nl" : "Bugrapport verzenden",
            "it" : "inviare un rapporto di errore",
            "pl" : "Wyślij raport o błędzie",
            "fr" : "Envoyer un rapport d'erreur",
            "cs" : "Odeslat chybové hlášení",
            "sk" : "Poslať hlásenie o chybe",
            "da" : "Sende en fejlrapport",
            "es" : "Enviar un informe de error",
            "fi" : "Lähettää virheilmoituksen",
            "sv" : "Skicka en felrapport",
        },
        "Durchschnittliche Bitrate": {
            "en" : "Average Bitrate",
            "de" : "Durchschnittliche Bitrate",
            "nl" : "Gemiddelde bitrate",
            "it" : "Bitrate medio",
            "pl" : "Średnia szybkość transmisji",
            "fr" : "Débit moyen",
            "cs" : "Průměrný datový tok",
            "sk" : "Priemerná bitová rýchlosť",
            "da" : "Gennemsnitlig bithastighed",
            "es" : "Tasa de bits promedio",
            "fi" : "Keskimääräinen bittinopeus",
            "sv" : "Genomsnittlig bithastighet",
        },
        "Durchschnittliche Framerate": {
            "en" : "Average Framerate",
            "de" : "Durchschnittliche Framerate",
            "nl" : "Gemiddelde beeldsnelheid",
            "it" : "Frequenza fotogrammi media",
            "pl" : "Średnia liczba klatek na sekundę",
            "fr" : "Fréquence d'images moyenne",
            "cs" : "Průměrná snímková frekvence",
            "sk" : "Priemerná snímková frekvencia",
            "da" : "Gennemsnitlig framerate",
            "es" : "Velocidad de fotogramas promedio",
            "fi" : "Keskimääräinen kuvataajuus",
            "sv" : "Genomsnittlig framerate",
        },
        "Verlustrate der Pakete": {
            "en" : "Packet Loss Ratio",
            "de" : "Verlustrate der Pakete",
            "nl" : "Verlies van pakketten",
            "it" : "Rapporto di perdita di pacchetti",
            "pl" : "Współczynnik utraty pakietów",
            "fr" : "Taux de perte de paquets",
            "cs" : "Poměr ztrátovosti paketů",
            "sk" : "Pomer straty paketov",
            "da" : "Pakketabsforhold",
            "es" : "Relación de pérdida de paquetes",
            "fi" : "Pakettien menetyssuhde",
            "sv" : "Paketförlustförhållande",
        },
        "Aufgetretene Fehler": {
            "en" : "Occured Errors",
            "de" : "Aufgetretene Fehler",
            "nl" : "Ondervonden fouten",
            "it" : "Errori verificatisi",
            "pl" : "Wystąpiły błędy",
            "fr" : "Erreurs survenues",
            "cs" : "Vyskytly se chyby",
            "sk" : "Vyskytli sa chyby",
            "da" : "Opståede fejl",
            "es" : "Errores Ocurridos",
            "fi" : "Tapahtuneita virheitä",
            "sv" : "Uppstått fel",
        },
        "Die Videofunktion wird nicht unterstützt.": {
            "en" : "The video function is not supported.",
            "de" : "Die Videofunktion wird nicht unterstützt.",
            "nl" : "De videofunctie wordt niet ondersteund.",
            "it" : "La funzione video non è supportata.",
            "pl" : "Funkcja wideo nie jest obsługiwana.",
            "fr" : "La fonction vidéo n'est pas prise en charge.",
            "cs" : "Funkce videa není podporována.",
            "sk" : "Funkcia videa nie je podporovaná.",
            "da" : "Videofunktionen er ikke understøttet.",
            "es" : "La función de vídeo no es compatible.",
            "fi" : "Videotoimintoa ei tueta.",
            "sv" : "Videofunktionen stöds inte.",
        },
        "Die Audiofunktion wird nicht unterstützt.": {
            "en" : "The audio function is not supported.",
            "de" : "Die Audiofunktion wird nicht unterstützt.",
            "nl" : "De audiofunctie wordt niet ondersteund.",
            "it" : "La funzione audio non è supportata.",
            "pl" : "Funkcja audio nie jest obsługiwana.",
            "fr" : "La fonction audio n'est pas prise en charge.",
            "cs" : "Funkce zvuku není podporována.",
            "sk" : "Funkcia zvuku nie je podporovaná.",
            "da" : "Lydfunktionen er ikke understøttet.",
            "es" : "La función de audio no es compatible.",
            "fi" : "Äänitoimintoa ei tueta.",
            "sv" : "Ljudfunktionen stöds inte.",
        },
        "Grund": {
            "en" : "Reason",
            "de" : "Grund",
            "nl" : "Grond",
            "it" : "Motivo",
            "pl" : "Powód",
            "fr" : "Raison",
            "cs" : "Důvod",
            "sk" : "Dôvod",
            "da" : "Grund",
            "es" : "Razón",
            "fi" : "Syy",
            "sv" : "Anledning",
        },

        //ScreenSharingPanel
        "Screen Sharing Fenster anzeigen": {
            "en" : "Show screen-sharing window",
            "de" : "Screen-Sharing Fenster anzeigen",
            "nl" : "Scherm delen venster tonen",
            "it" : "Mostra la finestra di condivisione dello schermo",
            "pl" : "Pokaż okno udostępniania ekranu",
            "fr" : "Afficher la fenêtre de partage d'écran",
            "cs" : "Zobrazit okno pro sdílení obrazovky",
            "sk" : "Zobraziť okno zdieľania obrazovky",
            "da" : "Vis skærmdelingsvindue",
            "es" : "Mostrar ventana para compartir pantalla",
            "fi" : "Näytä näytön jakamisikkuna",
            "sv" : "Visa skärmdelningsfönster",
        },
        "Screen Sharing Fenster ausblenden": {
            "en" : "Hide screen-sharing window",
            "de" : "Screen Sharing Fenster ausblenden",
            "nl" : "Scherm delen venster verbergen",
            "it" : "Nascondi la finestra di condivisione dello schermo",
            "pl" : "Ukryj okno udostępniania ekranu",
            "fr" : "Masquer la fenêtre de partage d'écran",
            "cs" : "Skrýt okno pro sdílení obrazovky",
            "sk" : "Skryť okno zdieľania obrazovky",
            "da" : "Skjul vinduet til skærmdeling",
            "es" : "Ocultar ventana para compartir pantalla",
            "fi" : "Piilota näytön jakamisikkuna",
            "sv" : "Dölj fönster för skärmdelning",
        },

        // ChatTab
        "Nachrichten": {
            "en" : "Messages",
            "de" : "Nachrichten",
            "nl" : "Bericht",
            "it" : "Messaggi",
            "pl" : "Wiadomości",
            "fr" : "Messages",
            "cs" : "Zprávy",
            "sk" : "Správy",
            "da" : "Meddelelser",
            "es" : "Mensajes",
            "fi" : "Viestit",
            "sv" : "Meddelanden",
        },
        "Ihre Nachricht eingeben...": {
            "en" : "Please enter your message...",
            "de" : "Bitte geben Sie Ihre Nachricht ein...",
            "nl" : "Voer uw bericht in...",
            "it" : "Inserire il messaggio...",
            "pl" : "Proszę wpisać swoją wiadomość...",
            "fr" : "Veuillez entrer votre message...",
            "cs" : "Zadejte prosím svou zprávu...",
            "sk" : "Zadajte svoju správu...",
            "da" : "Indtast venligst din besked ...",
            "es" : "Por favor, introduzca su mensaje...",
            "fi" : "Kirjoita viestisi...",
            "sv" : "Skriv ditt meddelande...",
        },

        // ParticipantTab
        "Teilnehmende": {
            "en" : "Participants",
            "de" : "Teilnehmer",
            "nl" : "Deelnemende",
            "it" : "Partecipanti",
            "pl" : "Uczestnicy",
            "fr" : "Participants",
            "cs" : "Účastníci",
            "sk" : "Účastníci",
            "da" : "Deltagere",
            "es" : "Participantes",
            "fi" : "Osallistujat",
            "sv" : "Deltagare",
        },
        "Teilnehmende suchen": {
            "en" : "Search for participants",
            "de" : "Teilnehmer suchen",
            "nl" : "Deelnemers zoeken",
            "it" : "Cerca i partecipanti",
            "pl" : "Wyszukaj uczestników",
            "fr" : "Rechercher des participants",
            "cs" : "Vyhledávání účastníků",
            "sk" : "Vyhľadávanie účastníkov",
            "da" : "Søg efter deltagere",
            "es" : "Buscar participantes",
            "fi" : "Etsi osallistujia",
            "sv" : "Sök efter deltagare",
        },
        "Zu Raum des Teilnehmer gehen": {
            "en" : "Go to the participant's room",
            "de" : "Gehen Sie in den Teilnehmerraum",
            "nl" : "Ga naar de kamer van de deelnemer",
            "it" : "Vai alla stanza del partecipante",
            "pl" : "Przejdź do pokoju uczestnika",
            "fr" : "Aller dans la salle du participant",
            "cs" : "Přejít do místnosti účastníka",
            "sk" : "Prejsť do miestnosti účastníka",
            "da" : "Gå til deltagerens rum",
            "es" : "Ir a la sala del participante",
            "fi" : "Siirry osallistujan huoneeseen",
            "sv" : "Gå till deltagarens rum",
        },
        "Teilnehmer stummschalten": {
            "en" : "Mute participant",
            "de" : "Teilnehmer stummschalten",
            "nl" : "Deelnemers dempen",
            "it" : "Silenziare il partecipante",
            "pl" : "Wycisz uczestnika",
            "fr" : "Mettre le participant en sourdine",
            "cs" : "Ztlumit účastníka",
            "sk" : "Vypnúť zvuk účastníka",
            "da" : "Mute deltageren",
            "es" : "Silenciar a un participante",
            "fi" : "Mykistä osallistuja",
            "sv" : "Stänbg av deltagarens ljud",
        },
        "Teilnehmer Entfernen": {
            "en" : "Remove participant",
            "de" : "Teilnehmer entfernen",
            "nl" : "Deelnemers verwijderen",
            "it" : "Rimuovere il partecipante",
            "pl" : "Usuń uczestnika",
            "fr" : "Supprimer un participant",
            "cs" : "Odebrat účastníka",
            "sk" : "Odstrániť účastníka",
            "da" : "Fjern deltager",
            "es" : "Eliminar participante",
            "fi" : "Poista osallistuja",
            "sv" : "Ta bort deltagare",
        },
        "Video des Teilnehmer ausstellen": {
            "en" : "Switch off the participant's video",
            "de" : "Video des Teilnehmers ausschalten",
            "nl" : "Video van de deelnemer tentoonstellen",
            "it" : "Disattivare il video del partecipante",
            "pl" : "Wyłączyć wideo uczestnika",
            "fr" : "Désactiver la vidéo du participant",
            "cs" : "Vypnout video účastníka",
            "sk" : "Vypnúť video účastníka",
            "da" : "Sluk deltagerens video",
            "es" : "Apagar el vídeo del participante",
            "fi" : "Sammuta osallistujan video",
            "sv" : "Stäng av deltagarens video",
        },

        // Navigation
        "Sprachauswahl": {
            "en" : "Language",
            "de" : "Sprachauswahl",
            "nl" : "Taalkeuze",
            "it" : "Selezione linguaggio",
            "pl" : "Wybór języka",
            "fr" : "Sélection de la langue",
            "cs" : "Výběr jazyka",
            "sk" : "Výber jazyka",
            "da" : "Vælg sprog",
            "es" : "Selección de idioma",
            "fi" : "Kielen valinta",
            "sv" : "Välj språk",
        },
        "Vollbildmodus": {
            "en" : "Fullscreen",
            "de" : "Vollbildmodus",
            "nl" : "Volledig scherm",
            "it" : "Modalità a schermo intero",
            "pl" : "Tryb pełnoekranowy",
            "fr" : "Mode plein écran",
            "cs" : "Režim celé obrazovky",
            "sk" : "Režim celej obrazovky",
            "da" : "Fuldskærmstilstand",
            "es" : "Modo de pantalla completa",
            "fi" : "Koko näytön tila",
            "sv" : "Helskärmsläge",
        },
        "Hilfe": {
            "en" : "Help",
            "de" : "Hilfe",
            "nl" : "Help",
            "it" : "Aiuto",
            "pl" : "Pomoc",
            "fr" : "Aide",
            "cs" : "Nápověda",
            "sk" : "Nápoveda",
            "da" : "Hjælp",
            "es" : "Ayuda",
            "fi" : "Ohjeistus",
            "sv" : "Hjälp",
        },
        "Kontakt": {
            "en" : "Contact",
            "de" : "Kontakt",
            "nl" : "Contact",
            "it" : "Contatti",
            "pl" : "Kontakt",
            "fr" : "Contactez",
            "cs" : "Kontakt",
            "sk" : "Kontakt",
            "da" : "Kontakt",
            "es" : "Póngase en contacto con",
            "fi" : "Ota yhteyttä",
            "sv" : "Kontakta oss",
        },
        "Shop": {
            "en" : "Shop",
            "de" : "Shop",
            "nl" : "Shop",
            "it" : "Shop",
            "pl" : "Sklep",
            "fr" : "Boutique",
            "cs" : "Obchod",
            "sk" : "Obchod",
            "da" : "Shop",
            "es" : "Tienda",
            "fi" : "Verkkokauppa",
            "sv" : "Shop",
        },

        // ModeratorMenue
        "Bildschirm teilen": {
            "en" : "Share screen",
            "de" : "Bildschirm teilen",
            "nl" : "Scherm delen",
            "it" : "Condivisione schermo",
            "pl" : "Ekran udostępniania",
            "fr" : "Écran de partage",
            "cs" : "Sdílet obrazovku",
            "sk" : "Zdieľať obrazovku",
            "da" : "Del skærmen",
            "es" : "Compartir pantalla",
            "fi" : "Jaa näyttö",
            "sv" : "Dela skärmen",
        },
        "Bildschirm teilen abbrechen": {
            "en" : "Cancel Share screen",
            "de" : "Bildschirm teilen abbrechen",
            "nl" : "Scherm delen annuleren",
            "it" : "Non condividere schermo",
            "pl" : "Anuluj udostępnianie ekranu",
            "fr" : "Annuler l'écran de partage",
            "cs" : "Zrušení sdílení obrazovky",
            "sk" : "Zrušenie zdieľania obrazovky",
            "da" : "Annuller skærmdeling",
            "es" : "Cancelar la pantalla Compartir",
            "fi" : "Peruuta näytön jakaminen",
            "sv" : "Avbryt Dela skärm",
        },
        "Alle Teilnehmer stummschalten": {
            "en" : "Mute all participants",
            "de" : "Alle Teilnehmer stummschalten",
            "nl" : "Alle deelnemers dempen",
            "it" : "Disattivare l'audio di tutti i partecipanti",
            "pl" : "Wycisz wszystkich uczestników",
            "fr" : "Couper le son de tous les participants",
            "cs" : "Ztlumení všech účastníků",
            "sk" : "Stlmenie všetkých účastníkov",
            "da" : "Mute alle deltagere",
            "es" : "Silenciar a todos los participantes",
            "fi" : "Mykistä kaikki osallistujat",
            "sv" : "Stäng av alla deltagares ljud",
        },
        "Geführter Modus aktivieren": {
            "en" : "Activate guided mode",
            "de" : "Geführten Modus aktivieren",
            "nl" : "Geleide modus activeren",
            "it" : "Attivare la modalità guidata",
            "pl" : "Aktywuj tryb nawigacji",
            "fr" : "Activer le mode guidé",
            "cs" : "Aktivace režimu s průvodcem",
            "sk" : "Aktivácia režimu so sprievodcom",
            "da" : "Aktivér guidet tilstand",
            "es" : "Activar el modo guiado",
            "fi" : "Aktivoi ohjattu tila",
            "sv" : "Aktivera guidat läge",
        },
        "Geführter Modus deaktivieren": {
            "en" : "Deactivate guided mode",
            "de" : "Geführten Modus deaktivieren",
            "nl" : "Geleide modus deactiveren",
            "it" : "Disattivare la modalità guidata",
            "pl" : "Dezaktywuj tryb nawigacji",
            "fr" : "Désactiver le mode guidé",
            "cs" : "Deaktivace řízeného režimu",
            "sk" : "Deaktivácia riadeného režimu",
            "da" : "Deaktivér guidet tilstand",
            "es" : "Desactivar el modo guiado",
            "fi" : "Ohjatun tilan poistaminen käytöstä",
            "sv" : "Inaktivera guidat läge",
        },
        "Videos aller Teilnehmer ausstellen": {
            "en" : "Switch off videos of all participants",
            "de" : "Videos aller Teilnehmer ausschalten",
            "nl" : "Video's van alle deelnemers tentoonstellen",
            "it" : "Disattivare i video di tutti i partecipanti",
            "pl" : "Wyłącz wideo wszystkich uczestników",
            "fr" : "Désactiver les vidéos de tous les participants",
            "cs" : "Vypnutí videí všech účastníků",
            "sk" : "Vypnutie videí všetkých účastníkov",
            "da" : "Slå alle deltageres videoer fra",
            "es" : "Desactivar los vídeos de todos los participantes",
            "fi" : "Sammuta kaikkien osallistujien videot",
            "sv" : "Stäng av alla deltagares videor",
        },
        "Alle Teilnehmer Entfernen": {
            "en" : "Remove all participants",
            "de" : "Alle Teilnehmer Entfernen",
            "nl" : "Alle deelnemers verwijderen",
            "it" : "Rimuovere tutti i partecipanti",
            "pl" : "Usuń wszystkich uczestników",
            "fr" : "Supprimer tous les participants",
            "cs" : "Odstranit všechny účastníky",
            "sk" : "Odstrániť všetkých účastníkov",
            "da" : "Fjern alle deltagere",
            "es" : "Eliminar a todos los participantes",
            "fi" : "Poista kaikki osallistujat",
            "sv" : "Ta bort alla deltagare",
        },

        // AudioTest
        "Der Audiotest simuliert eine Verbindung zum Server. Sie können ihre Audioübertragung dann abhören, um sie zu überprüfen.": {
            "en" : "The audio test simulates a connection to the server. You can listen to your audio transmission to monitor it.",
            "de" : "Der Audiotest simuliert eine Verbindung zum Server. Sie können Ihre Audioübertragung dann abhören, um sie zu überprüfen.",
            "nl" : "De audiotest simuleert een verbinding met de server. U kunt dan luisteren naar hun audiotransmissie om het te controleren.",
            "it" : "Il test audio simula una connessione al server. È possibile ascoltare la trasmissione audio per monitorarla.",
            "pl" : "Test audio symuluje połączenie z serwerem. Możesz odsłuchać  transmisję audio, aby ją monitorować.",
            "fr" : "Le test audio simule une connexion au serveur. Vous pouvez écouter votre transmission audio pour la contrôler.",
            "cs" : "Zvukový test simuluje připojení k serveru. Můžete si poslechnout zvukový přenos a sledovat jej.",
            "sk" : "Test zvuku simuluje pripojenie k serveru. Môžete si vypočuť svoj zvukový prenos a sledovať ho.",
            "da" : "Lydtesten simulerer en forbindelse til serveren. Du kan lytte til din lydtransmission for at kontrollere den.",
            "es" : "La prueba de audio simula una conexión con el servidor. Puede escuchar la transmisión de audio para supervisarla.",
            "fi" : "Äänitesti simuloi yhteyttä palvelimeen. Voit kuunnella äänilähetystä seurataksesi sitä.",
            "sv" : "Ljudtestet simulerar en anslutning till servern. Du kan lyssna på din ljudöverföring för att övervaka den.",
        },
        "Wiederholen": {
            "en" : "Retry",
            "de" : "Wiederholen",
            "nl" : "Herhaal",
            "it" : "Riprova",
            "pl" : "Spróbuj ponownie",
            "fr" : "Réessayer",
            "cs" : "Opakování",
            "sk" : "Opakovanie",
            "da" : "Forsøg igen",
            "es" : "Reintentar",
            "fi" : "Yritä uudelleen",
            "sv" : "Försök igen",
        },
        "Verbindung zum Server fehlgeschlagen!": {
            "en" : "Connection to the server failed!",
            "de" : "Verbindung zum Server fehlgeschlagen!",
            "nl" : "Verbinding met de server is mislukt!",
            "it" : "Connessione al server fallita!",
            "pl" : "Połączenie z serwerem nie powiodło się!",
            "fr" : "La connexion au serveur a échoué !",
            "cs" : "Připojení k serveru se nezdařilo!",
            "sk" : "Pripojenie k serveru sa nepodarilo!",
            "da" : "Forbindelsen til serveren mislykkedes!",
            "es" : "La conexión con el servidor ha fallado.",
            "fi" : "Yhteys palvelimeen epäonnistui!",
            "sv" : "Anslutningen till servern misslyckades!",
        },

        // ShareDialog
        "Raum teilen": {
            "en" : "Share room",
            "de" : "Raum teilen",
            "nl" : "Ruimte delen",
            "it" : "Condividi stanza",
            "pl" : "Udostępnij ekran",
            "fr" : "Chambre partagée",
            "cs" : "Sdílejte pokoj",
            "sk" : "Zdieľať izbu",
            "da" : "Del værelse",
            "es" : "Habitacion compartida",
            "fi" : "Jaa huone",
            "sv" : "Dela rum",
        },
        "Tour teilen": {
            "en" : "Share tour",
            "de" : "Tour teilen",
            "nl" : "Tour delen",
            "it" : "Condividi tour",
            "pl" : "Udostępnij wycieczkę",
            "fr" : "Partager la visite",
            "cs" : "Sdílejte prohlídku",
            "sk" : "Zdieľať prehliadku",
            "da" : "Del rundvisning",
            "es" : "Compartir recorrido",
            "fi" : "Jaa kiertue",
            "sv" : "Dela turné",
        },

        // TroubleShooting
        "Ich höre niemanden": {
            "en" : "I don't hear anyone",
            "de" : "Ich höre niemanden",
            "nl" : "Ich höre niemanden",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Das Standardkommunikationsgerät umstellen (Windows 10)": {
            "en" : "Change the default communication device (Windows 10)",
            "de" : "Das Standardkommunikationsgerät umstellen (Windows 10)",
            "nl" : "Das Standardkommunikationsgerät umstellen (Windows 10)",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Öffnen Sie die Soundeinstellungen (am besten direkt in die Suche eingeben). Scrollen Sie nach unten, bis Sie zur Überschrift \"Verwandte Einstellungen\" gelangen. Darunter klicken Sie auf \"Sound-Systemsteuerung\". Es öffnet sich ein kleines Fenster, in dem verschiedene Ausgabegeräte zu sehen sind. Machen Sie einen Rechtsklick auf das Gerät, das Sie verwenden möchten und klicken Sie dann auf \"Als Standardkommunikationsgerät auswählen\". Nun sollte das korrekte Gerät für die Ausgabe verwendet werden.": {
            "en" : "Open the sound settings (it is best to enter it directly into the search). Scroll down until you get to the Related Settings heading. Below that click on \"Sound Control Panel\". A small window opens in which various output devices can be seen. Right-click the device you want to use, then click \"Set as default communication device\". The correct device should now be used for the output.",
            "de" : "Öffnen Sie die Soundeinstellungen (am besten direkt in die Suche eingeben). Scrollen Sie nach unten, bis Sie zur Überschrift \"Verwandte Einstellungen\" gelangen. Darunter klicken Sie auf \"Sound-Systemsteuerung\". Es öffnet sich ein kleines Fenster, in dem verschiedene Ausgabegeräte zu sehen sind. Machen Sie einen Rechtsklick auf das Gerät, das Sie verwenden möchten und klicken Sie dann auf \"Als Standardkommunikationsgerät auswählen\". Nun sollte das korrekte Gerät für die Ausgabe verwendet werden.",
            "nl" : "Öffnen Sie die Soundeinstellungen (am besten direkt in die Suche eingeben). Scrollen Sie nach unten, bis Sie zur Überschrift \"Verwandte Einstellungen\" gelangen. Darunter klicken Sie auf \"Sound-Systemsteuerung\". Es öffnet sich ein kleines Fenster, in dem verschiedene Ausgabegeräte zu sehen sind. Machen Sie einen Rechtsklick auf das Gerät, das Sie verwenden möchten und klicken Sie dann auf \"Als Standardkommunikationsgerät auswählen\". Nun sollte das korrekte Gerät für die Ausgabe verwendet werden.",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Ich höre Echogeräusche": {
            "en" : "I hear echo noises",
            "de" : "Ich höre Echogeräusche",
            "nl" : "Ich höre Echogeräusche",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Ein Headset verwenden": {
            "en" : "Use a headset",
            "de" : "Ein Headset verwenden",
            "nl" : "Ein Headset verwenden",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Wenn Sie ein Notebook oder ein ähnliches Gerät verwenden, kann es sein, dass der Lautsprecher und das Mikrofon zu nah beieinander sind und der Ton aus dem Lautsprecher direkt vom Mikrofon aufgenommen wird. Dadurch hört Ihr Gegenüber die eigene Stimme, was es schwieriger macht, sich auf das Gespräch zu konzentrieren. Wenn dies der Fall ist, schießen Sie bitte ein Headset an.": {
            "en" : "If you are using a notebook or similar device, the speaker and microphone may be too close together and the sound from the speaker may be picked up directly by the microphone. This allows the other person to hear their own voice, which makes it more difficult to concentrate on the conversation. If so, plug in a headset.",
            "de" : "Wenn Sie ein Notebook oder ein ähnliches Gerät verwenden, kann es sein, dass der Lautsprecher und das Mikrofon zu nah beieinander sind und der Ton aus dem Lautsprecher direkt vom Mikrofon aufgenommen wird. Dadurch hört Ihr Gegenüber die eigene Stimme, was es schwieriger macht, sich auf das Gespräch zu konzentrieren. Wenn dies der Fall ist, schießen Sie bitte ein Headset an.",
            "nl" : "Wenn Sie ein Notebook oder ein ähnliches Gerät verwenden, kann es sein, dass der Lautsprecher und das Mikrofon zu nah beieinander sind und der Ton aus dem Lautsprecher direkt vom Mikrofon aufgenommen wird. Dadurch hört Ihr Gegenüber die eigene Stimme, was es schwieriger macht, sich auf das Gespräch zu konzentrieren. Wenn dies der Fall ist, schießen Sie bitte ein Headset an.",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Nur ein Mikrofon und einen Lautsprecher pro Raum verwenden": {
            "en" : "Use only one microphone and speaker per room",
            "de" : "Nur ein Mikrofon und einen Lautsprecher pro Raum verwenden",
            "nl" : "Nur ein Mikrofon und einen Lautsprecher pro Raum verwenden",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Wenn Sie mit weiteren Personen an einer Tour teilnehmen und sich diese Personen im selben Raum befinden wie Sie, kann es sein, dass das ihre Stimme mehrmals aufgenommen wird und Echo Geräusche entstehen. Achten Sie daher darauf, dass nur ein Microfon aktiviert ist oder die Personen weitgenug auseinander sitzen.": {
            "en" : "If you take part in a tour with other people and these people are in the same room as you, their voices may be recorded several times and echo noises may arise. Make sure that only one microphone is activated or that people are sitting far enough apart.",
            "de" : "Wenn Sie mit weiteren Personen an einer Tour teilnehmen und sich diese Personen im selben Raum befinden wie Sie, kann es sein, dass das ihre Stimme mehrmals aufgenommen wird und Echo Geräusche entstehen. Achten Sie daher darauf, dass nur ein Microfon aktiviert ist oder die Personen weitgenug auseinander sitzen.",
            "nl" : "Wenn Sie mit weiteren Personen an einer Tour teilnehmen und sich diese Personen im selben Raum befinden wie Sie, kann es sein, dass das ihre Stimme mehrmals aufgenommen wird und Echo Geräusche entstehen. Achten Sie daher darauf, dass nur ein Microfon aktiviert ist oder die Personen weitgenug auseinander sitzen.",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Meine Kamera/Mikrofon wird nicht erkannt": {
            "en" : "My camera / microphone is not recognized",
            "de" : "Meine Kamera/Mikrofon wird nicht erkannt",
            "nl" : "Meine Kamera/Mikrofon wird nicht erkannt",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Erlauben Sie den Zugriff": {
            "en" : "Allow access",
            "de" : "Erlauben Sie den Zugriff",
            "nl" : "Erlauben Sie den Zugriff",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Beim Öffnen der Mikrofon- und Kameraeinstellungen fragt der Browser nach dem Zugriff auf Ihre Mikrofone und Kameras. Ohne Ihre Erlaubnis kann die Anwendung ihre Kamera und Mikrofon nicht nutzen. Überprüfen Sie die Mikrofon- und Kameraeinstellungen ihres Browsers, falls Sie nicht nach dem Zugriff gefragt werden.": {
            "en" : "When opening the microphone and camera settings, the browser asks for access to your microphones and cameras. The application cannot use its camera and microphone without your permission. Check your browser's microphone and camera settings if you are not asked for access.",
            "de" : "Beim Öffnen der Mikrofon- und Kameraeinstellungen fragt der Browser nach dem Zugriff auf Ihre Mikrofone und Kameras. Ohne Ihre Erlaubnis kann die Anwendung ihre Kamera und Mikrofon nicht nutzen. Überprüfen Sie die Mikrofon- und Kameraeinstellungen ihres Browsers, falls Sie nicht nach dem Zugriff gefragt werden.",
            "nl" : "Beim Öffnen der Mikrofon- und Kameraeinstellungen fragt der Browser nach dem Zugriff auf Ihre Mikrofone und Kameras. Ohne Ihre Erlaubnis kann die Anwendung ihre Kamera und Mikrofon nicht nutzen. Überprüfen Sie die Mikrofon- und Kameraeinstellungen ihres Browsers, falls Sie nicht nach dem Zugriff gefragt werden.",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Ändern Sie die Datenschutzeinstellungen": {
            "en" : "Change privacy settings",
            "de" : "Ändern Sie die Datenschutzeinstellungen",
            "nl" : "Ändern Sie die Datenschutzeinstellungen",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Ihr Betriebssystem kann dem Browser den generellen Zugriff auf die Kamera und Mikrofon blockieren. Überprüfen sie die Datenschutzeinstellungen ihres Betriebssystemes, und erlauben Sie ihrem Browser ggf. Zugriff!": {
            "en" : "Your operating system can block general access to the camera and microphone from the browser. Check the data protection settings of your operating system and, if necessary, allow your browser access!",
            "de" : "Ihr Betriebssystem kann dem Browser den generellen Zugriff auf die Kamera und Mikrofon blockieren. Überprüfen sie die Datenschutzeinstellungen ihres Betriebssystemes, und erlauben Sie ihrem Browser ggf. Zugriff!",
            "nl" : "Ihr Betriebssystem kann dem Browser den generellen Zugriff auf die Kamera und Mikrofon blockieren. Überprüfen sie die Datenschutzeinstellungen ihres Betriebssystemes, und erlauben Sie ihrem Browser ggf. Zugriff!",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Kamera/Mikrofon wird bereits genutzt": {
            "en" : "The camera / microphone is already in use",
            "de" : "Kamera/Mikrofon wird bereits genutzt",
            "nl" : "Kamera/Mikrofon wird bereits genutzt",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Es könnte sein, dass andere Anwendungen wie Microsoft Teams oder ein anderer geöffneter Browser bereits Kamera oder Mikrofon nutzen. Stellen Sie sicher, das ihre Kamera nicht von anderen Anwendungen genutzt wird und schließen Sie diese Anwendungen gegebenenfalls.": {
            "en" : "It could be that other applications such as Microsoft Teams or another open browser are already using the camera or microphone. Make sure that your camera is not being used by other applications and close these applications if necessary.",
            "de" : "Es könnte sein, dass andere Anwendungen wie Microsoft Teams oder ein anderer geöffneter Browser bereits Kamera oder Mikrofon nutzen. Stellen Sie sicher, das ihre Kamera nicht von anderen Anwendungen genutzt wird und schließen Sie diese Anwendungen gegebenenfalls.",
            "nl" : "Es könnte sein, dass andere Anwendungen wie Microsoft Teams oder ein anderer geöffneter Browser bereits Kamera oder Mikrofon nutzen. Stellen Sie sicher, das ihre Kamera nicht von anderen Anwendungen genutzt wird und schließen Sie diese Anwendungen gegebenenfalls.",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Beim Audiotest wird meine Audio nicht übertragen": {
            "en" : "My audio is not transmitted during the audio test",
            "de" : "Beim Audiotest wird meine Audio nicht übertragen",
            "nl" : "Beim Audiotest wird meine Audio nicht übertragen",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Die Firewall-Einstellungen anpassen": {
            "en" : "Adjust the firewall settings",
            "de" : "Die Firewall-Einstellungen anpassen",
            "nl" : "Die Firewall-Einstellungen anpassen",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Zur Kommunikation mit dem Server ist es notwendig, dass Sie den TCP Port 443 freigeben. Wenn Sie eine Whitelist für Domains pflegen, ist es außerdem wichtig, dass Sie die Domains \"*.tokbox.com\" und \"*.opentok.com\" (ohne Anführungszeichen) in die Liste einfügen.": {
            "en" : "To communicate with the server it is necessary that you enable the TCP port 443. If you maintain a whitelist for domains, it is also important that you include the domains \"* .tokbox.com\" and \"* .opentok.com\" (without quotation marks) in the list.",
            "de" : "Zur Kommunikation mit dem Server ist es notwendig, dass Sie den TCP Port 443 freigeben. Wenn Sie eine Whitelist für Domains pflegen, ist es außerdem wichtig, dass Sie die Domains \"*.tokbox.com\" und \"*.opentok.com\" (ohne Anführungszeichen) in die Liste einfügen.",
            "nl" : "Zur Kommunikation mit dem Server ist es notwendig, dass Sie den TCP Port 443 freigeben. Wenn Sie eine Whitelist für Domains pflegen, ist es außerdem wichtig, dass Sie die Domains \"*.tokbox.com\" und \"*.opentok.com\" (ohne Anführungszeichen) in die Liste einfügen.",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Die Proxy-Einstellungen anpassen": {
            "en" : "Adjust the proxy settings",
            "de" : "Die Proxy-Einstellungen anpassen",
            "nl" : "Die Proxy-Einstellungen anpassen",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Am besten funktioniert der Videochat ohne einen Proxy. Wenn Sie ohne Proxy keinen Zugang zum Internet haben, sollten Sie einen transparenten Proxy verwenden oder den Proxy im Browser für HTTPS-Verbindungen konfigurieren.": {
            "en" : "The video chat works best without a proxy. If you cannot access the Internet without a proxy, you should use a transparent proxy or configure the proxy in the browser for HTTPS connections",
            "de" : "Am besten funktioniert der Videochat ohne einen Proxy. Wenn Sie ohne Proxy keinen Zugang zum Internet haben, sollten Sie einen transparenten Proxy verwenden oder den Proxy im Browser für HTTPS-Verbindungen konfigurieren.",
            "nl" : "Am besten funktioniert der Videochat ohne einen Proxy. Wenn Sie ohne Proxy keinen Zugang zum Internet haben, sollten Sie einen transparenten Proxy verwenden oder den Proxy im Browser für HTTPS-Verbindungen konfigurieren.",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Sonstiges": {
            "en" : "Other",
            "de" : "Sonstiges",
            "nl" : "Sonstiges",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Unterstützte Browser": {
            "en" : "Supported browsers",
            "de" : "Unterstützte Browser",
            "nl" : "Unterstützte Browser",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Am besten wird die Anwendung von den Browsern Firefox, Chrome, Safari, Opera und Edge unterstützt. Achten Sie bitte darauf, dass Sie die jeweils aktuelle Version installiert haben und aktualisieren Sie diese ggf. manuel, da die Browser dies nicht immer automatisch tun.": {
            "en" : "The application is best supported by the browsers Firefox, Chrome, Safari, Opera and Edge. Please make sure that you have installed the latest version and update it manually if necessary, as the browser does not always do this automatically.",
            "de" : "Am besten wird die Anwendung von den Browsern Firefox, Chrome, Safari, Opera und Edge unterstützt. Achten Sie bitte darauf, dass Sie die jeweils aktuelle Version installiert haben und aktualisieren Sie diese ggf. manuel, da die Browser dies nicht immer automatisch tun.",
            "nl" : "Am besten wird die Anwendung von den Browsern Firefox, Chrome, Safari, Opera und Edge unterstützt. Achten Sie bitte darauf, dass Sie die jeweils aktuelle Version installiert haben und aktualisieren Sie diese ggf. manuel, da die Browser dies nicht immer automatisch tun.",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },

        // ProductMenu
        "Nicht verfügbar":{
            "en" :"Not available",
            "de" :"Nicht verfügbar",
            "nl" :"Niet beschikbaar",
            "it" : "Non disponibile",
            "pl" : "Niedostępne",
            "fr" : "Pas disponible",
            "cs" : "Není dostupný",
            "sk" : "Nie je k dispozícií",
            "da" : "Ikke tilgængelig",
            "es" : "No disponible",
            "fi" : "Ei saatavilla",
            "sv" : "Inte tillgänglig",
        },
        "Nicht verfügbar_digitalService":{
            "en" :"Not available",
            "de" :"Nicht verfügbar",
            "nl" :"Niet beschikbaar",
            "it" : "Non disponibile",
            "pl" : "Niedostępne",
            "fr" : "Pas disponible",
            "cs" : "Již brzy, v případě zájmu o individuální řešení nás kontaktujte",
            "sk" : "Už čoskoro, v prípade záujmu o individuálne riešenie nás kontaktujte",
            "da" : "Ikke tilgængelig",
            "es" : "No disponible",
            "fi" : "Ei saatavilla",
            "sv" : "Inte tillgänglig",
        },
        "Bildergalerie öffnen": {
            "en" : "Open picture gallery",
            "de" : "Bildergalerie öffnen",
            "nl" : "Open Fotogalerij",
            "it" : "Aprire la galleria di immagini",
            "pl" : "Otwórz galerię zdjęć",
            "fr" : "Ouvrir la galerie d'images",
            "cs" : "Otevřít galerii",
            "sk" : "Otvoriť galériu",
            "da" : "Åbn billedgalleri",
            "es" : "Abrir galería de imágenes",
            "fi" : "Avaa kuvagalleria",
            "sv" : "Öppna bildgalleri",
        },
        "Videothek ansehen": {
            "en" : "Open video gallery",
            "de" : "Videothek ansehen",
            "nl" : "Open Videotheek",
            "it" : "Aprire la videoteca",
            "pl" : "Otwórz bibliotekę wideo",
            "fr" : "Ouvrir la vidéothèque",
            "cs" : "Otevřít knihovnu videí",
            "sk" : "Otvorte videotéku",
            "da" : "Åbn videobibliotek",
            "es" : "Abrir videoteca",
            "fi" : "Avaa videokirjasto",
            "sv" : "Öppna videobiblioteket",
        },
        "Dokumente downloaden": {
            "en" : "Download documents",
            "de" : "Dokumente downloaden",
            "nl" : "Documenten downloaden",
            "it" : "Download dei documenti",
            "pl" : "Pobierz dokumenty",
            "fr" : "Télécharger des documents",
            "cs" : "Stáhnout dokumenty",
            "sk" : "Stiahnuť dokumenty",
            "da" : "Hent dokumenter",
            "es" : "Descargar documentos",
            "fi" : "Ladattava sisältö",
            "sv" : "Ladda ner dokument",
        },
        "Produkte erleben": {
            "en" : "Experience products",
            "de" : "Produkte erleben",
            "nl" : "Ervaar Producten",
            "it" : "Scoprire il prodotto",
            "pl" : "Poznaj produkty",
            "fr" : "Découvrez les produits",
            "cs" : "O produktu",
            "sk" : "O produkte",
            "da" : "Udforsk produkter",
            "es" : "Ver productos",
            "fi" : "Tutustu tuotteeseen",
            "sv" : "Upplev produkter",
        },
        "Weitere Informationen": {
            "en" : "Further information",
            "de" : "Weitere Informationen",
            "nl" : "Meer Informatie",
            "it" : "Ulteriori informazioni",
            "pl" : "Dalsze informacje",
            "fr" : "Informations complémentaires",
            "cs" : "Další informace",
            "sk" : "Ďalšie informácie",
            "da" : "Flere oplysninger",
            "es" : "Más información",
            "fi" : "Lisätietoja",
            "sv" : "Mer information",
        },
        "Video ansehen": {
            "en" : "Watch video",
            "de" : "Video ansehen",
            "nl" : "Bekijk Video",
            "it" : "Guardare il video",
            "pl" : "Obejrzyj film",
            "fr" : "Regarder la vidéo",
            "cs" : "Podívejte se na video",
            "sk" : "Pozrite si video",
            "da" : "Se video",
            "es" : "Ver vídeo",
            "fi" : "Katso video",
            "sv" : "Titta på video",
        },
        "Schadensfall ansehen": {
            "en" : "Open damage case",
            "de" : "Schadensfall ansehen",
            "nl" : "Bekijk Geval van Schade",
            "it" : "In caso di danno",
            "pl" : "Przypadek uszkodzenia",
            "fr" : "Cas d'endommagement",
            "cs" : "Případ poškození",
            "sk" : "Prípad poškodenia",
            "da" : "Skadestilfælde",
            "es" : "Caso de daños",
            "fi" : "Vahinkoesimerkki",
            "sv" : "Skadefall",
        },
        "Shop öffnen": {
            "en" : "Open Shop",
            "de" : "Shop öffnen",
            "nl" : "Open Shop",
            "it" : "Negozio aperto",
            "pl" : "Otwórz sklep",
            "fr" : "Boutique ouverte",
            "cs" : "Otevřít e-shop",
            "sk" : "Otvoriť e-shop",
            "da" : "Åbn shop",
            "es" : "Tienda abierta",
            "fi" : "Siirry verkkokauppaan",
            "sv" : "Öppen butik",
        },
        "Website öffnen": {
            "en" : "Open website",
            "de" : "Website öffnen",
            "nl" : "Open Website",
            "it" : "Aprire il sito web",
            "pl" : "Otwórz stronę internetową",
            "fr" : "Ouvrir le site web",
            "cs" : "Otevřít webové stránky",
            "sk" : "Otvoriť webové stránky",
            "da" : "Åbn hjemmeside",
            "es" : "Abrir el sitio web",
            "fi" : "Siirry verkkosivuille",
            "sv" : "Öppna webbplatsen",
        },

        "24/7 ÜBERWACHUNG": {
            "en" : "24/7 MONITORING",
            "de" : "24/7 ÜBERWACHUNG",
            "nl" : "24/7 TOEZICHT HOUDEN",
            "it" : "Monitoraggio 24/7",
            "pl" : "Monitoring 24/7",
            "fr" : "Surveillance 24/7",
            "cs" : "Monitorování 24/7",
            "sk" : "Monitorovanie 24 /7 ",
            "da" : "Overvågning",
            "es" : "Monitorización 24/7",
            "fi" : "24/7 valvonta",
            "sv" : "Övervakning dygnet runt",
        },
        "Überwachung rund um die Uhr, auch zwischen gesetzlich vorgeschriebenen Prüfintervallen. ": {
            "en" : "Monitoring around the clock, even between legally prescribed inspection intervals.",
            "de" : "Überwachung rund um die Uhr, auch zwischen gesetzlich vorgeschriebenen Prüfintervallen.",
            "nl" : "Controle de klok rond, zelfs tussen de wettelijk voorgeschreven inspectie-intervallen.",
            "it" : "Situazione sempre sotto controllo, anche all’interno degli intervalli di ispezione prescritti.",
            "pl" : "Monitoring przez całą dobę, nawet pomiędzy prawnie przewidzianymi okresami przeglądów.",
            "fr" : "",
            "cs" : "Monitoring around the clock, even between legally prescribed inspection intervals.",
            "sk" : "Monitoring around the clock, even between legally prescribed inspection intervals.",
            "da" : "Overvågning døgnet rundt, selv mellem lovligt foreskrevne inspektionsintervaller.",
            "es" : "",
            "fi" : "Valvonta ympäri vuorokauden, myös lakisääteisten tarkastusvälien välillä.",
            "sv" : "Övervakning dygnet runt, även mellan lagstadgade inspektionsintervall.",
        },
        "ALARM IN ECHTZEIT": {
            "en" : "Real-time notification",
            "de" : "ALARM IN ECHTZEIT",
            "nl" : "WAARSCHUWING IN REALTIME",
            "it" : "Notifica in tempo reale",
            "pl" : "Powiadomienia w czasie rzeczywistym",
            "fr" : "Notification en temps réel",
            "cs" : "Upozornění v reálném čase",
            "sk" : "Upozornenie v reálnom čase",
            "da" : "Alarm i realtid",
            "es" : "Notificación en tiempo real",
            "fi" : "Reaaliaikainen ilmoitus",
            "sv" : "Notiser och larm i realtid",
        },
        "Per E-Mail und/oder SMS auf Ihr Smartphone, Tablet bzw. Desktop-PC, Sie können unmittelbar reagieren.": {
            "en" : "By email and/or SMS to your smartphone, tablet or desktop PC, you can respond immediately.",
            "de" : "Per E-Mail und/oder SMS auf Ihr Smartphone, Tablet bzw. Desktop-PC, Sie können unmittelbar reagieren.",
            "nl" : "Via e-mail en/of SMS naar uw smartphone, tablet of desktop PC kunt u onmiddellijk reageren.",
            "it" : "Con una e-mail e/o un SMS sul vostro dispositivo (cellulare, tablet o PC desktop), potete reagire con prontezza.",
            "pl" : "Poprzez e-mail i/lub SMS na smartfon, tablet lub komputer stacjonarny, możesz natychmiast zareagować.",
            "fr" : "",
            "cs" : "By email and/or SMS to your smartphone, tablet or desktop PC, you can respond immediately.",
            "sk" : "By email and/or SMS to your smartphone, tablet or desktop PC, you can respond immediately.",
            "da" : "Via e-mail og/eller sms til din smartphone, tablet eller stationære pc, så du kan reagere med det samme.",
            "es" : "",
            "fi" : "Sähköpostitse ja/tai tekstiviestillä älypuhelimeesi, tablettiisi tai pöytätietokoneeseesi, joten voit reagoida välittömästi.",
            "sv" : "Via e-post och/eller SMS till din smartphone, surfplatta eller stationära dator kan du reagera omedelbart.",
        },
        "VOLLE ÜBERSICHT UND KONTROLLE": {
            "en" : "Complete overview and control",
            "de" : "VOLLE ÜBERSICHT UND KONTROLLE",
            "nl" : "VOLLEDIG OVERZICHT EN CONTROLE",
            "it" : "Controllo e panoramica completa",
            "pl" : "Pełny przegląd i kontrola",
            "fr" : "Vue d'ensemble et contrôle complet",
            "cs" : "Kompletní přehled a kontrola",
            "sk" : "Kompletný prehľad a kontrola",
            "da" : "Fuldt overblik og kontrol",
            "es" : "Visión general y control completos",
            "fi" : "Täydellinen yleiskuva ja valvonta",
            "sv" : "Fullständig överblick och kontroll",
        },
        "Sicheres Monitoring auch bei mehreren Gefahrstofflagern bzw. Auffangwannen. ": {
            "en" : "Safe monitoring even with multiple hazardous material storage or collection trays.",
            "de" : "Sicheres Monitoring auch bei mehreren Gefahrstofflagern bzw. Auffangwannen. ",
            "nl" : "Veilig toezicht, zelfs met meerdere opslagplaatsen voor gevaarlijke stoffen of opvangbakken.",
            "it" : "Monitoraggio sicuro e completo, anche in caso di molteplici sistemi di stoccaggio differenti. ",
            "pl" : "Bezpieczny monitoring nawet przy kilku magazynach materiałów niebezpiecznych lub wannach wychwytowych.",
            "fr" : "",
            "cs" : "Safe monitoring even with multiple hazardous material storage or collection trays.",
            "sk" : "Safe monitoring even with multiple hazardous material storage or collection trays.",
            "da" : "Sikker overvågning selv med flere lagre til farlige medier eller opsamlingskar.",
            "es" : "",
            "fi" : "Turvallinen valvonta, vaikka käytössä olisi useita vaarallisten aineiden varastoja tai valuma-altaita.",
            "sv" : "Säker övervakning även av flera miljöcontainers eller uppsamlingskärl. ",
        },
        "AUTOMATISCHE DOKUMENTATION ": {
            "en" : "Automated documentation",
            "de" : "AUTOMATISCHE DOKUMENTATION",
            "nl" : "AUTOMATISCHE DOCUMENTATIE",
            "it" : "Documentazione automatizzata",
            "pl" : "Zautomatyzowana dokumentacja",
            "fr" : "Documentation automatisée",
            "cs" : "Automatizovaná dokumentace",
            "sk" : "Automatizovaná dokumentácia",
            "da" : "Automatisk dokumentation",
            "es" : "Documentación automatizada",
            "fi" : "Automatisoitu dokumentointi",
            "sv" : "Automatiserad dokumentation",
        },
        "PDF Reports können exportiert und für Audits verwendet werden. ": {
            "en" : "PDF reports can be exported and used for audits.",
            "de" : "PDF Reports können exportiert und für Audits verwendet werden. ",
            "nl" : "PDF-rapporten kunnen worden geëxporteerd en gebruikt voor audits.",
            "it" : "Report in PDF possono essere esportati ed utilizzati per gli audit.",
            "pl" : "Raporty w formacie PDF mogą być eksportowane i wykorzystywane do audytów.",
            "fr" : "",
            "cs" : "PDF reports can be exported and used for audits.",
            "sk" : "PDF reports can be exported and used for audits.",
            "da" : "PDF-rapporter kan eksporteres og bruges til revisioner.",
            "es" : "",
            "fi" : "PDF-raportit voidaan ladata ja käyttää tarkastuksissa.",
            "sv" : "PDF-rapporter kan exporteras och användas för revisioner.",
        },
        "MODERNE ÜBERTRAGUNGSTECHNOLOGIE": {
            "en" : "MODERN TRANSMISSION TECHNOLOGY",
            "de" : "MODERNE ÜBERTRAGUNSTECHNOLOGIE",
            "nl" : "MODERNE TRANSMISSIETECHNOLOGIE",
            "it" : "Moderna tecnologia di trasmissione",
            "pl" : "Nowoczesna technika transmisji",
            "fr" : "Technologie de transmission moderne",
            "cs" : "Moderní přenosová technologie",
            "sk" : "Moderná prenosová technológia",
            "da" : "Moderne overvågningsteknologi",
            "es" : "Moderna tecnología de transmisión",
            "fi" : "Nykyaikainen siirtotekniikka",
            "sv" : "Modern överföringsteknik",
        },
        "Narrowband IoT sorgt für zuverlässige Funktion über das Mobilfunknetz. ": {
            "en" : "Narrowband IoT ensures reliable function via the mobile network.",
            "de" : "Narrowband IoT sorgt für zuverlässige Funktion über das Mobilfunknetz.",
            "nl" : "Narrowband IoT zorgt voor een betrouwbare werking via het mobiele netwerk.",
            "it" : "La tecnologia Narrowband IoT assicura alte prestazione via rete mobile.",
            "pl" : "Narrowband IoT zapewnia niezawodne funkcjonowanie za pośrednictwem sieci komórkowej.",
            "fr" : "",
            "cs" : "Narrowband IoT ensures reliable function via the mobile network.",
            "sk" : "Narrowband IoT ensures reliable function via the mobile network.",
            "da" : "Narrowband IoT sikrer en pålidelig funktion via mobilnettet.",
            "es" : "",
            "fi" : "Kapeakaistainen IoT varmistaa luotettavan toiminnan mobiiliverkon kautta.",
            "sv" : "Smalbandigt IoT säkerställer pålitlig funktion via mobilnätet.",
        },

        // 3D Viewer
        "BESTSELLER": {
            "en" : "BESTSELLER",
            "de" : "BESTSELLER",
            "nl" : "BESTSELLER",
            "it" : "Bestseller",
            "pl" : "Bestseller",
            "fr" : "Meilleure vente",
            "cs" : "Bestseller",
            "sk" : "Bestseller",
            "da" : "Bestseller",
            "es" : "El más vendido",
            "fi" : "Suosittu",
            "sv" : "Kundfavoriter",
        },
        "TECHNISCHE DATEN": {
            "en" : "TECHNICAL DATA",
            "de" : "TECHNISCHE DATEN",
            "nl" : "TECHNISCHE GEGEVENS",
            "it" : "Dati tecnici",
            "pl" : "Dane techniczne",
            "fr" : "Données techniques",
            "cs" : "Technické údaje",
            "sk" : "Technické údaje",
            "da" : "Tekniske data",
            "es" : "Datos técnicos",
            "fi" : "Tekniset tiedot",
            "sv" : "Tekniska uppgifter",
        },
        "PRODUKTMAßE": {
            "en" : "PRODUCT DIMENSIONS",
            "de" : "PRODUKTMAßE",
            "nl" : "PRODUCTAFMETINGEN",
            "it" : "Dimensioni del prodotto",
            "pl" : "Wymiary produktu",
            "fr" : "Dimensions du produit",
            "cs" : "Rozměry výrobku",
            "sk" : "Rozmery výrobku",
            "da" : "Produktets dimensioner",
            "es" : "Dimensiones del producto",
            "fi" : "Tuotteen mitat",
            "sv" : "Produktdimensioner",
        },
        "Im Shop ansehen": {
            "en" : "View in store",
            "de" : "Im Shop ansehen",
            "nl" : "Bekijk in de Winkel",
            "it" : "Visualizza nello shop",
            "pl" : "Zobacz w sklepie",
            "fr" : "Voir en magasin",
            "cs" : "Zobrazit v DENIOS shopu",
            "sk" : "Zobraziť v DENIOS shope",
            "da" : "Se i shoppen",
            "es" : "Ver en tienda",
            "fi" : "Näytä verkkokaupassa",
            "sv" : "Visa i shoppen",
        },

        // WebsiteDialogue
        "Dokument ansehen ➝": {
            "en" : "Open Dokument",
            "de" : "Dokument ansehen",
            "nl" : "Bekijk Documenten",
            "it" : "Aprire il documento",
            "pl" : "Otwórz dokument",
            "fr" : "Ouvrir le document",
            "cs" : "Otevřít dokument",
            "sk" : "Otvoriť dokument",
            "da" : "Åbn dokument",
            "es" : "Abrir documento",
            "fi" : "Avaa asiakirja",
            "sv" : "Öppna dokument",
        },
        "Schadensfall": {
            "en" : "Damage case",
            "de" : "Schadensfall",
            "nl" : "Geval van schade",
            "it" : "In caso di danno",
            "pl" : "Przypadek uszkodzenia",
            "fr" : "Cas d'avarie",
            "cs" : "Případ poškození",
            "sk" : "Prípad poškodenia",
            "da" : "Skadestilfælde",
            "es" : "Caso de daños",
            "fi" : "Vahinkoesimerkki",
            "sv" : "Skadefall",
        },
        "InformationPDF": {
            "en" : "Information PDF",
            "de" : "Informations-PDF",
            "nl" : "Informatie PDF",
            "it" : "PDF informativo",
            "pl" : "Informacja PDF",
            "fr" : "Information PDF",
            "cs" : "Informace PDF",
            "sk" : "Informácie PDF",
            "da" : "Information PDF",
            "es" : "Información PDF",
            "fi" : "Informaatio PDF",
            "sv" : "Information PDF",
        },
        "Dokumente": {
            "en" : "Documents",
            "de" : "Dokumente",
            "nl" : "Documenten",
            "it" : "Documentazione",
            "pl" : "Dokumenty",
            "fr" : "Documents",
            "cs" : "Dokumenty",
            "sk" : "Dokumenty",
            "da" : "Dokumenter",
            "es" : "Documentos",
            "fi" : "Asiakirjat",
            "sv" : "Dokument",
        },
        "Bildergalerie": {
            "en" : "Image Gallery",
            "de" : "Bildergalerie",
            "nl" : "Bildergalerie",
            "it" : "Galleria immagini",
            "pl" : "Galeria zdjęć",
            "fr" : "Galerie d'images",
            "cs" : "Galerie obrázků",
            "sk" : "Galéria obrázkov",
            "da" : "Billedgalleri",
            "es" : "Galería de imágenes",
            "fi" : "Kuvagalleria",
            "sv" : "Bildgalleri",
        },
        "DENIOS connect für smart stores": {
            "en" : "DENIOS connect for smart stores ",
            "de" : "DENIOS connect für smart stores",
            "nl" : "DENIOS connect voor slimme winkels",
            "it" : "DENIOS connect per Smart Store",
            "pl" : "DENIOS connect dla inteligentnych magazynów",
            "fr" : "DENIOS connect pour les magasins intelligents",
            "cs" : "DENIOS connect pro chytré sklady",
            "sk" : "DENIOS connect pre múdre sklady",
            "da" : "DENIOS connect til smartstores",
            "es" : "DENIOS connect para almacenes inteligentes",
            "fi" : "DENIOS connect älykkääseen varastointiin",
            "sv" : "DENIOS connect för smart förvaring",
        },
        "SpillGuard® connect": {
            "en" : "SpillGuard® connect",
            "de" : "SpillGuard® connect",
            "nl" : "SpillGuard® connect",
            "it" : "SpillGuard® connect",
            "pl" : "SpillGuard® connect",
            "fr" : "SpillGuard® connect",
            "cs" : "SpillGuard® connect",
            "sk" : "SpillGuard® connect",
            "da" : "SpillGuard® connect",
            "es" : "SpillGuard® connect",
            "fi" : "SpillGuard® connect",
            "sv" : "SpillGuard® connect",
        },
        "DENIOS connect für Raumsysteme": {
            "en" : "DENIOS connect for hazardous materials storage",
            "de" : "DENIOS connect für Raumsysteme",
            "nl" : "DENIOS connect voor ruimtesystemen",
            "it" : "DENIOS connect per depositi di stoccaggio",
            "pl" : "DENIOS connect dla magazynów materiałów niebezpiecznych",
            "fr" : "DENIOS connect pour le stockage des matières dangereuses",
            "cs" : "DENIOS connect pro sklady nebezpečných látek",
            "sk" : "DENIOS connect pre sklady na nebezpečné látky",
            "da" : "DENIOS connect til opbevaring af farlige medier",
            "es" : "DENIOS connect para el almacenamiento de sustancias peligrosas",
            "fi" : "DENIOS connect vaarallisten aineiden varastointiin",
            "sv" : "DENIOS connect för kemikalieförvaring",
        },
        "DENIOS Zusammenlagerungs-Checker-App": {
            "en" : "DENIOS Hazmat-Storage-Checker-App",
            "de" : "DENIOS Zusammenlagerungs-Checker-App",
            "nl" : "DENIOS Consolidatie-Checker-App",
            "it" : "DENIOS Hazmat-Storage-Checker-App",
            "pl" : "DENIOS Hazmat-Storage-Checker-App",
            "fr" : "DENIOS Hazmat-Storage-Checker-App",
            "cs" : "DENIOS Hazmat-Storage-Checker-App",
            "sk" : "DENIOS Hazmat-Storage-Checker-App",
            "da" : "DENIOS Hazmat-Storage-Checker-App",
            "es" : "DENIOS Hazmat-Storage-Checker-App",
            "fi" : "DENIOS Hazmat-Storage-Checker-sovellus",
            "sv" : "DENIOS app Check av kemikalieförvaring ",
        },
        "DENIOS Software Solution Quentic": {
            "en" : "DENIOS Software Solution Quentic ",
            "de" : "DENIOS Software Solution Quentic",
            "nl" : "DENIOS Software Solution Quentic",
            "it" : "DENIOS Software Solution Quentic",
            "pl" : "DENIOS Software Solution Quentic",
            "fr" : "DENIOS Software Solution Quentic",
            "cs" : "DENIOS Software Solution Quentic",
            "sk" : "DENIOS Software Solution Quentic",
            "da" : "DENIOS Software Solution Quentic",
            "es" : "DENIOS Software Solution Quentic",
            "fi" : "DENIOS Software Solution Quentic",
            "sv" : "DENIOS Software Solution Quentic",
        },
        "DENIOS Mengen-Checker-App": {
            "en" : "-\tDENIOS Quantity -Checker-App ",
            "de" : "DENIOS Mengen-Checker-App",
            "nl" : "DENIOS Hoeveelheid-Checker-App",
            "it" : "App DENIOS Quantity-Checker",
            "pl" : "DENIOS Quantity-Checker-App",
            "fr" : "DENIOS Quantity-Checker-App",
            "cs" : "DENIOS Quantity-Checker-App",
            "sk" : "DENIOS Quantity-Checker-App",
            "da" : "DENIOS Quantity-Checker-App",
            "es" : "DENIOS Quantity-Checker-App",
            "fi" : "DENIOS Quantity-Checker-sovellus",
            "sv" : "DENIOS app för kontroll av kvantitet",
        },
        "Schadensfall Brand": {
            "en" : "Case Study - Fire Damage",
            "de" : "Schadensfall Brand",
            "nl" : "Schadegeval brand",
            "it" : "Caso di danno da incendio",
            "pl" : "Uszkodzenie w przypadku pożaru",
            "fr" : "Cas d'incendie",
            "cs" : "Případ poškození požárem",
            "sk" : "Prípad poškodenia požiarom",
            "da" : "Skadestilfælde brand",
            "es" : "Caso de daños incendio",
            "fi" : "Vahinkoesimerkki tulipalo",
            "sv" : "Skadefall brand",
        },
        "Schadensfall Klimaanlage": {
            "en" : "Case Study - Air Conditioning System Damage",
            "de" : "Schadensfall Klimaanlage",
            "nl" : "Schadegeval airconditioning",
            "it" : "Caso di danno all'aria condizionata",
            "pl" : "Przypadek uszkodzenia klimatyzacji",
            "fr" : "Cas de sinistre climatisation",
            "cs" : "Případ poškození klimatizace",
            "sk" : "Prípad poškodenia klimatizácie",
            "da" : "Skadestilfælde klimaanlæg",
            "es" : "Caso de avería aire acondicionado",
            "fi" : "Vahinkoesimerkki ilmastointi",
            "sv" : "Skadefall luftkonditionering",
        },
        "Schadensfall Leckage": {
            "en" : "Case Study - Leakage Damage",
            "de" : "Schadensfall Leckage",
            "nl" : "Schadegeval Lekkage",
            "it" : "Perché è così importante il monitoraggio delle condizioni?",
            "pl" : "Przypadek uszkodzenia - wyciek",
            "fr" : "Cas de dommages - fuite",
            "cs" : "Poškození pouzdro - únik",
            "sk" : "Prípad poškodenia - únik",
            "da" : "Skade Lækage",
            "es" : "Caso de daño - fuga",
            "fi" : "Vahinkotapaus - vuoto",
            "sv" : "Skador Läckage",
        },
        "DENIOS connect": {
            "en" : "DENIOS connect",
            "de" : "DENIOS connect",
            "nl" : "DENIOS connect",
            "it" : "DENIOS connect",
            "pl" : "DENIOS connect",
            "fr" : "DENIOS connect",
            "cs" : "DENIOS connect",
            "sk" : "DENIOS connect",
            "da" : "DENIOS connect",
            "es" : "DENIOS connect",
            "fi" : "DENIOS connect",
            "sv" : "DENIOS connect",
        },
        "Über Denios": {
            "en" : "About Denios",
            "de" : "Über Denios",
            "nl" : "Over Denios",
            "it" : "Informazioni su Denios",
            "pl" : "O Denios",
            "fr" : "A propos de Denios",
            "cs" : "O společnosti Denios",
            "sk" : "O spoločnosti Denios",
            "da" : "Om DENIOS",
            "es" : "Acerca de Denios",
            "fi" : "Tietoa DENIOKSESTA",
            "sv" : "Om Denios",
        },

        // --- PDFs ---
        "216374_PSD_Operating-instr_010_INT_low.pdf": {
            "en" : "Operating instructions PolySafe Depot",
            "de" : "Betriebsanleitung PolySafe-Depot",
            "nl" : "Gebruiksaanwijzing PolySafe-Depot",
            "it" : "Manuale operativo depositi PolySafe",
            "pl" : "Instrukcja obsługi składów PolySafe ",
            "fr" : "Mode d'emploi PolySafe Depot",
            "cs" : "Návod k obsluze PolySafe Depot",
            "sk" : "Návod na použitie PolySafe Depot",
            "da" : "Brugsanvisning PolySafe depot",
            "es" : "Manual de instrucciones PolySafe Depot",
            "fi" : "Käyttöohjeet PolySafe-varastokaapeille",
            "sv" : "Bruksanvisningar PolySafe IBC och fatskåp",
        },
        "Product_data_sheet_Datenblatt_SecuExTypW_breit.pdf": {
            "en" : "Operating instructions Secu Ex with barrel turner type W",
            "de" : "DENIOS Fasslifter Secu Ex mit Fasswender Typ W",
            "nl" : "DENIOS Fasslifter Secu Ex mit Fasswender Typ W",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },      
        "274227_pro-line_FK_Auffangwannen_Operating-instr_001_INT_low.pdf": {
            "en" : "Operating instructions pro-line FK spill sumps",
            "de" : "Betriebsanleitung pro-line FK Auffangwannen",
            "nl" : "Gebruiksaanwijzing pro-line FK Opvangbakken",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "257744_Auffangwanne_pl_fuer_IBC_Operating-instr_004_INT_low.pdf": {
            "en" : "Operating instructions Spill pallet pro-line IK mae of polyethylene (PE)",
            "de" : "Betriebsanleitung Auffangwannen pro-line FK aus Polyethylen (PE)",
            "nl" : "Gebruiksaanwijzing Opvangbakken pro-line FK van Polyethylen (PE)",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "OperInstr_SpillTraySmall_pro-line_int_04_low.pdf": {
            "en" : "Spill trays for small containers",
            "de" : "Betriebsanleitung Kleingebindewannen",
            "nl" : "Gebruiksaanwijzing kleine containerbakken",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "OperInstr_SteelSafe-Depots_int_low.pdf": {
            "en" : "Operating instructions SteelSafe hazardous material depots",
            "de" : "Betriebsanleitung SteelSafe-Gefahrstoffdepots",
            "nl" : "Gebruiksaanwijzing SteelSafe-Depots voor gevaarlijke stoffen",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },

        // Secu Ex Betriebsanleitung
        "241109_Secu-Ex_004_CS_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "DoC_ContainerAndDrumPump_PumpingStation_de.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "241109_Secu-Ex_005_DA_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "241109_Secu-Ex_004_FI_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "241109_Secu-Ex_004_IT_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "241109_Secu-Ex_004_NO_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "241109_Secu-Ex_004_PL_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "241109_Secu-Ex_004_PT_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "241109_Secu-Ex_004_SK_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "241109_Secu-Ex_004_SV_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "241109_Secu-Ex_005_INT_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "241109_OperInstr_Secu-Ex_005_hu_low.pdf": {
            "en" : "Operating instructions Secu Ex",
            "de" : "Betriebsanleitung Secu Ex",
            "nl" : "Gebruiksaanwijzing Secu Ex",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },

        // Steckregale
        "105682_Gefahrstoffregal_Operating-instr_005_INT_low.pdf": {
            "en" : "Operating instructions Hazmat shelving/boltless shelving",
            "de" : "Betriebsanleitung Gefahrstoff-/Steckregale",
            "nl" : "Gebruiksaanwijzing Gevaarlijke stof-/Boutloze rekken",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "BA_Gefahrstoffregal_004_IT_low.pdf": {
            "en" : "Operating instructions Hazmat shelving/boltless shelving",
            "de" : "Betriebsanleitung Gefahrstoff-/Steckregale",
            "nl" : "Gebruiksaanwijzing Gevaarlijke stof-/Boutloze rekken",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },

        // Palettenregal
        "Operating_manual_BA_Palettenregal_004_DE.pdf": {
            "en" : "Operating instructions Pallet rack",
            "de" : "Betriebsanleitung Palettenregal",
            "nl" : "Gebruiksaanwijzing Gevaarlijke stof-/Boutloze rekken",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Operating_manual_BA_Palettenregal_004_EN.pdf": {
            "en" : "Operating instructions Pallet rack",
            "de" : "Betriebsanleitung Palettenregal",
            "nl" : "Gebruiksaanwijzing Gevaarlijke stof-/Boutloze rekken",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Operating_manual_BA_Palettenregal_004_ES.pdf": {
            "en" : "Operating instructions Pallet rack",
            "de" : "Betriebsanleitung Palettenregal",
            "nl" : "Gebruiksaanwijzing Gevaarlijke stof-/Boutloze rekken",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Operating_manual_BA_Palettenregal_004_fr-FR.pdf": {
            "en" : "Operating instructions Pallet rack",
            "de" : "Betriebsanleitung Palettenregal",
            "nl" : "Gebruiksaanwijzing Gevaarlijke stof-/Boutloze rekken",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Palettenregal_Operating-instr_005_de_low.pdf": {
            "en" : "Operating instructions Pallet rack",
            "de" : "Betriebsanleitung Palettenregal",
            "nl" : "Gebruiksaanwijzing Gevaarlijke stof-/Boutloze rekken",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },

        // Combi-Regal
        "OperInstr_Combi-Rack_008_de.pdf": {
            "en" : "User Manual Combi-Rack",
            "de" : "Betriebsanleitung Combi-Regal",
            "nl" : "Gebruiksaanwijzing Combi-Plank",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },    
        "OperInstr_Combi-Rack_008_en.pdf": {
            "en" : "User Manual Combi-Rack",
            "de" : "Betriebsanleitung Combi-Regal",
            "nl" : "Gebruiksaanwijzing Combi-Plank",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },  
        "OperInstr_Combi-Rack_008_es.pdf": {
            "en" : "User Manual Combi-Rack",
            "de" : "Betriebsanleitung Combi-Regal",
            "nl" : "Gebruiksaanwijzing Combi-Plank",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        }, 
        "OperInstr_Combi-Rack_008_fr.pdf": {
            "en" : "User Manual Combi-Rack",
            "de" : "Betriebsanleitung Combi-Regal",
            "nl" : "Gebruiksaanwijzing Combi-Plank",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        }, 
        "OperInstr_Combi-Rack_008_it.pdf": {
            "en" : "User Manual Combi-Rack",
            "de" : "Betriebsanleitung Combi-Regal",
            "nl" : "Gebruiksaanwijzing Combi-Plank",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        }, 
        "OperInstr_Combi-Rack_008_pl.pdf": {
            "en" : "User Manual Combi-Rack",
            "de" : "Betriebsanleitung Combi-Regal",
            "nl" : "Gebruiksaanwijzing Combi-Plank",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        }, 
        
        // Baugenehmigung
        "Approval_DIBt_PEspillpallet_de.pdf": {
            "en" : "General construction permit",
            "de" : "Allgemeine Bauaufsichtliche Zulassung/Allgemeine Baurtgenehmigung",
            "nl" : "General construction permit",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "ZU_Z-40.22-563_DE_002.pdf": {
            "en" : "General construction permit",
            "de" : "Allgemeine Bauaufsichtliche Zulassung/Allgemeine Baurtgenehmigung",
            "nl" : "General construction permit",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Approval_DIBt_PEsump_proline_for3IBC_de.pdf": {
            "en" : "General construction permit",
            "de" : "Allgemeine Bauaufsichtliche Zulassung/Allgemeine Baurtgenehmigung",
            "nl" : "General construction permit",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "ZU_Z-40.22-421_DE_007.pdf": {
            "en" : "General construction permit",
            "de" : "Allgemeine Bauaufsichtliche Zulassung/Allgemeine Baurtgenehmigung",
            "nl" : "General construction permit",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Approval_DIBt_SpillPallet_baseline_in_polyethylene_de.pdf": {
            "en" : "General construction permit",
            "de" : "Allgemeine Bauaufsichtliche Zulassung/Allgemeine Baurtgenehmigung",
            "nl" : "General construction permit",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Appr_DIBt_Z-40_22-303_de.pdf": {
            "en" : "General construction permit",
            "de" : "Allgemeine Bauaufsichtliche Zulassung/Allgemeine Baurtgenehmigung",
            "nl" : "General construction permit",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "ZU_Z-40.22-559_DE_003.pdf": {
            "en" : "General construction permit",
            "de" : "Allgemeine Bauaufsichtliche Zulassung/Allgemeine Baurtgenehmigung",
            "nl" : "General construction permit",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
          
        // Auffangwannen Betriebsanleitungen
        "225296_Auffangwanne_bl_2_und_4_Faesser_Operating-instr_009_INT_low.pdf": {
            "en" : "Operating instructions Base-line polyethylene spill pallet",
            "de" : "Betriebsanleitung Auffangwannen base-line",
            "nl" : "Gebruiksaanwijzing Opvangbakken base-line",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "271452_Auffangwannen_bl_cl_Fass_und_IBC_Operating-instr_003_INT_low.pdf": {
            "en" : "Operating instructions Base-line polyethylene spill pallet",
            "de" : "Betriebsanleitung Auffangwannen base-line",
            "nl" : "Gebruiksaanwijzing Opvangbakken base-line",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "BA_Auffangwannen_005_PL.pdf": {
            "en" : "Operating instructions Base-line polyethylene spill pallet",
            "de" : "Betriebsanleitung Auffangwannen base-line",
            "nl" : "Gebruiksaanwijzing Opvangbakken base-line",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "262569_Auffangwannen_006_INT.pdf": {
            "en" : "Operating instructions Base-line polyethylene spill pallet",
            "de" : "Betriebsanleitung Auffangwannen base-line",
            "nl" : "Gebruiksaanwijzing Opvangbakken base-line",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "262569_Auffangwannen_006_INT_low.pdf": {
            "en" : "Operating instructions Base-line polyethylene spill pallet",
            "de" : "Betriebsanleitung Auffangwannen base-line",
            "nl" : "Gebruiksaanwijzing Opvangbakken base-line",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "262569_Auffangwannen_006_hu_low.pdf": {
            "en" : "Operating instructions Base-line polyethylene spill pallet",
            "de" : "Betriebsanleitung Auffangwannen base-line",
            "nl" : "Gebruiksaanwijzing Opvangbakken base-line",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },

        // Cubos Betriebsanleitung
        "221916_BA_Cubos_007_EN.pdf": {
            "en" : "User Manual Cubos hazardous materials depot",
            "de" : "Betriebsanleitung Gefahrstoffdepot Typ Cubos",
            "nl" : "Gebruiksaanwijzing Gefahrstoffdepot Typ Cubos",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "221916_BA_Cubos_007_FR.pdf": {
            "en" : "User Manual Cubos hazardous materials depot",
            "de" : "Betriebsanleitung Gefahrstoffdepot Typ Cubos",
            "nl" : "Gebruiksaanwijzing Gefahrstoffdepot Typ Cubos",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "221916_BA_Cubos_007_DE.pdf": {
            "en" : "User Manual Cubos hazardous materials depot",
            "de" : "Betriebsanleitung Gefahrstoffdepot Typ Cubos",
            "nl" : "Gebruiksaanwijzing Gefahrstoffdepot Typ Cubos",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "221916_BA_Cubos_007_ES.pdf": {
            "en" : "User Manual Cubos hazardous materials depot",
            "de" : "Betriebsanleitung Gefahrstoffdepot Typ Cubos",
            "nl" : "Gebruiksaanwijzing Gefahrstoffdepot Typ Cubos",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "221916_BA_Cubos_006_PL.pdf": {
            "en" : "User Manual Cubos hazardous materials depot",
            "de" : "Betriebsanleitung Gefahrstoffdepot Typ Cubos",
            "nl" : "Gebruiksaanwijzing Gefahrstoffdepot Typ Cubos",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },        

        "BA_185613_Bindevliese_Universal.pdf": {
            "en" : "User guide for UNIVERSAL absorbents",
            "de" : "Betriebsanleitung DENSORB® UNIVERSAL Bindevliese",
            "nl" : "Gebruiksaanwijzing Densorb",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "268041_DCS_Operating-instr_001_INT.pdf": {
            "en" : "Operating instructions DENSORB Caddy Small",
            "de" : "Betriebsanleitung DENSORB® Caddy Small",
            "nl" : "Gebruiksaanwijzing DENSORB Caddy Small",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "BA_185612_Bindevliese_Spezial.pdf": {
            "en" : "User guide for SPEZIAL absorbents",
            "de" : "Betriebsanleitung DENSORB® SPEZIAL Bindevliese",
            "nl" : "Gebruiksaanwijzing SPEZIAL - Bindevliese",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "OperInstr_DENSORB_EmergencySpillKit_Caddy_int.pdf": {
            "en" : "User Manual DENSORB Caddy Dispensing trolley",
            "de" : "Betriebsanleitung DENSORB® Caddy Spenderwagen",
            "nl" : "Gebruiksaanwijzing DENSORB Caddy Spenderwagen",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "264649_GSN_Mounting-instr_2019-06_low.pdf": {
            "en" : "Assemply instruction Gas cylinder store GSN",
            "de" : "Montageanleitung Gasflaschenlager GSN",
            "nl" : "Montageanleitung Gasflaschenlager GSN",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "276267_GSN_Operating-instr_002_INT_low.pdf": {
            "en" : "Operating instructions GSN",
            "de" : "Betriebsanleitung GSN",
            "nl" : "Gebruiksaanwijzing GSN",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "OperatingInstructions_FALCON_Drainage_Funnel_int_low.pdf": {
            "en" : "Operating instructions drainage funnel",
            "de" : "Betriebsanleitung Abtropftrichter",
            "nl" : "Gebruiksaanwijzing drainage funnel",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "OperInstr_FALCON_IBC_Funnel_FullSize_001_int_low.pdf": {
            "en" : "Operating instructions Falcon IBC-Trichter FullSize",
            "de" : "Betriebsanleitung Falcon IBC-Trichter FullSize",
            "nl" : "Gebruiksaanwijzing Falcon IBC-Trichter FullSize",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Operating_Instructions_DipTank_int_low.pdf": {
            "en" : "Operating instructions Dip tank",
            "de" : "Betriebsanleitung Tauchtank",
            "nl" : "Gebruiksaanwijzing Dip tank",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "OperInstr_ElectricDrumPump_Motor_de.pdf": {
            "en" : "User Manual Universalmotore MAII / MI 4",
            "de" : "Betriebsanleitung Universalmotore MAII / MI 4",
            "nl" : "Gebruiksaanwijzing Universalmotore MAII / MI 4",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        }, 

        // Missing Translations
        "PDS_SmartStore_Adjustmentheights_de.pdf": {
            "en" : "",
            "de" : "Einstellhöhen SmartStore-Schränke",
            "nl" : "",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "PDS_LithiumIonBattery_ChargingCabinet_SmartStore_de.pdf": {
            "en" : "",
            "de" : "Produktinformationen - Gefahrstoffschrank SmartStore",
            "nl" : "",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "SelectionGuide_BoxesForLithiumBatteries_de.pdf": {
            "en" : "Selection guide boxes for lithium batteries",
            "de" : "Auswahlhilfe Boxen für Lithium-Akkus",
            "nl" : "Selection guide boxes for lithium batteries",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "OperInstr_Pump_accessories_nozzles_de.pdf": {
            "en" : "",
            "de" : "Originalbetriebsanleitung ZAPFPISTOLEN",
            "nl" : "",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        }, 
        "OperInstr_ContainerAndDrumPump_PumpingStation_de.pdf": {
            "en" : "",
            "de" : "Originalbetriebsanleitung PUMPWERKE für Fass- und Behälterpumpen",
            "nl" : "",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        }, 
        "DoC_ElectricDrumPump_Motor_de.pdf": {
            "en" : "",
            "de" : "EU-Konformitätserklärung",
            "nl" : "",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        }, 
        "DoC_ContainerAndDrumPump_PumpingStation_de.pdf": {
            "en" : "",
            "de" : "EU-Konformitätserklärung",
            "nl" : "",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        
        // Country Selection
        "Wählen Sie ein Land aus": {
            "en" : "Wählen Sie ein Land aus",
            "de" : "Wählen Sie ein Land aus",
            "nl" : "Wählen Sie ein Land aus",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        },
        "Wählen Sie einen Kontinent aus": {
            "en" : "Wählen Sie einen Kontinent aus",
            "de" : "Wählen Sie einen Kontinent aus",
            "nl" : "Wählen Sie einen Kontinent aus",
            "it" : "",
            "pl" : "",
            "fr" : "",
            "cs" : "",
            "sk" : "",
            "da" : "",
            "es" : "",
            "fi" : "",
            "sv" : "",
        }
    }
]

// Convert into I18n readable structure
let messages = { };
flux_config.languages.forEach(language => {
    let tmp = new Object;

    translation.forEach(t => {
        for(var key in t){
            var value = t[key];
            tmp[key] = value[language.shortCode];
        }
    });

    messages[language.shortCode] = tmp;
});

const i18n = new VueI18n({
    locale: 'de-DE', // set locale
    fallbackLocale: 'en', // set fallback locale
    silentFallbackWarn: true,
    messages, // set locale messages
});

export {i18n}